/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2019 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

// Event definitions
export const USER_ENTITLEMENT_MIX_LABEL = {
  PEARSON_DTC_ACTIVE: 'pearson_dtc_active',
  INTEGRATED_SMS_ACTIVE: 'integrated_sms_active',
  DIRECT_LEARNER_AND_SAET_ACTIVE: 'direct_learner_and_saet_active',
  DIGITAL_SAMPLES_ACTIVE: 'digital_samples_active',
  BLENDED_ACTIVE: 'blended_active',
  EXPIRED: 'Expired',
  NO_TITLE_ACTIVE: 'no_title_active',
  OTHER: 'other'
};

export const PROGRESS_STATUS = {
  COMPLETED: 'completed',
  IN_PROGRESS: 'inprogress',
  NOT_STARTED: 'notstarted',
  COMPLETED_LATE: 'completedPastDue'
};

export const SUBSCRIBER_STATUS = {
  SUBSCRIBER: 'subscriber',
  NON_SUBSCRIBER: 'non_subscriber',
  BUNDLE: 'bundle'
};

export const COURSE_CONFIGURATION_KEYS = {
  IS_AI_STUDY_ENABLED: 'isAIStudyEnabled',
  IS_STUDY_PREP_ENABLED: 'isStudyPrepEnabled',
  IS_UNASSIGNED_MCQ_ENABLED: 'isUnassignedMCQEnabled'
};

export const AET_EVENT = {
  EVENT_CATEGORY: {
    DASHBOARD: 'Dashboard',
    AI_INSERTED_QUESTION: 'AI-Inserted Question',
    COURSE_CREATION: 'Course Creation',
    COURSE_MANAGEMENT: 'Course Management',
    COURSE_ONBOARDING: 'Course Onboarding',
    GLOBAL_ASSIGNMENT_SETTINGS: 'Global Assignment Settings'
  },
  EVENT_LABEL: {
    INITIATE: 'loading',
    SUCCESS: 'Success',
    ERROR: 'Failed',
    ALL_ASSIGNMENTS: 'all_assignments',
    SINGLE_ASSIGNMENT: 'single_assignment',
    ALL_STUDENTS: 'all_students',
    SINGLE_STUDENT: 'single_student',
    SUCCESS_WITH_ERRORS: 'Success with Errors',
    CHANNELSVIDEO: 'channelsvideo',
    CHANNELSPRACTICE: 'channelspractice',
    CHANNELSVIDEO_CHANNELSPRACTICE: 'channelsvideo_channelspractice',
    TOGGLE_COURSE_RESOURCE_EVENT_LABEL: {
      [COURSE_CONFIGURATION_KEYS.IS_AI_STUDY_ENABLED]: 'AIST',
      [COURSE_CONFIGURATION_KEYS.IS_UNASSIGNED_MCQ_ENABLED]: 'AeT_MCQs',
      [COURSE_CONFIGURATION_KEYS.IS_STUDY_PREP_ENABLED]: 'StudyPrep'
    },
    PEARSON_PLUS_ETEXTBOOK_RESOURCES: 'Pearson+ eTextbook Resources',
    ASSIGNMENT_STATE_QUESTIONS: 'assignment_state_questions',
    ASSIGNMENT_STATE_STUDENTS: 'assignment_state_students',
    ASSIGNMENT_STATE: 'assignment_state',
    ASSIGNMENT_VIEW: 'assignment_view',
    ASSIGNMENTS_TAB: 'assignments_tab',
    REVIEW_STATE: 'review_state',
    STUDENT_VIEW: 'Student_View',
    EMPTY_STATE: 'empty_state',
    DUE_NEXT: 'due_next',
    UPCOMING: 'upcoming',
    PAST_DUE: 'past_due',
    ON: 'on',
    OFF: 'off',
    SINGLE_STUDENT_COURSE_PROGRESS: 'single_student_course_progress',
    ALL_COURSE_ASSIGNMENT_PROGRESS: 'all_course_assignment_progress',
    SINGLE_ASSIGNMENT_PROGRESS: 'single_assignment_progress',
    SINGLE_STUDENT_PROGRESS: 'single_student_progress',
    NOT_CORRECT: 'Not correct',
    NOT_RELEVANT: 'Not relevant',
    UNSAFE_HARMFUL: 'Unsafe/harmful',
    SOMETHING_ELSE: 'Something else',
    CURRENT: 'current',
    PAST: 'past',
    PREVIOUS_STEP: 'previous_step',
    TEMPORARY_ACCESS_EXPIRING: 'temporary_access_expiring'
  },
  EVENT_ACTION: {
    OPEN_ASSIGNMENT_QUESTIONS_AND_TOPICS: 'Open Assignment Questions & Topics',
    SELECT_ASSIGNMENT_DUE_DATE: 'Select Assignment Due Date',
    CANCEL_INDIVIDUAL_ASSIGNMENT_SETTING_EDITS: 'Cancel Individual Assignment Setting Edits',
    SAVE_ALL_COURSE_ASSIGNMENT_DRAFTS: 'Save All Course Assignment Drafts',
    PUBLISH_ALL_COURSE_ASSIGNMENTS: 'Publish All Course Assignments',
    LEARN_MORE_ABOUT_AET: 'Learn More About AET',
    SYLLABUS_UPLOADED_FOR_ASSIGNMENT_CREATION: 'Syllabus Uploaded for Assignment Creation',
    VIEW_ASSIGNMENTS_EMPTY_STATE: 'View Assignments Empty State',
    VIEW_CREATED_ASSIGNMENT_AET: 'View Create Assignment AET',
    OPEN_COURSE_SETTINGS: 'Click Open Course Settings',
    OPEN_GLOBAL_ASSIGNMENT_SETTINGS: 'Open Global Assignment Settings',
    CANCEL_GLOBAL_ASSIGNMENT_SETTING_CHANGES: 'Cancel Global Assignment Setting Changes',
    UPDATE_GLOBAL_ASSIGNMENT_SETTINGS: 'Update Global Assignment Settings',
    CLICK_ACCESS_EDUCATOR_GUIDES: 'Click Access Educator Guides',
    NEXT_ASSIGNMENT_DISPLAYED: 'View Next Assignment',
    UPDATE_INDIVIDUAL_ASSIGNMENT: 'Update Individual Assignment',
    DELETE_INDIVIDUAL_ASSIGNMENT: 'Delete Assignment',
    OPEN_ASSIGNMENT_DETAILS: 'Click Open Assignment Details',
    CANCEL_ALL_ASSIGNMENT_CREATION: 'Cancel All Assignment Creation',
    SAVE_ALL_ASSIGNMENT_SCHEDULING_SETTINGS: 'Save All Assignment Scheduling Settings',
    SAVE_ALL_ASSIGNMENT_CONTENT_MAPPINGS: 'Save All Assignment Content Mappings',
    ADD_CONTENT_TO_ASSIGNMENT: 'Add Content To Assignment',
    INITIATE_NEW_ASSIGNMENT_CREATION: 'Click Initiate New Assignment Creation',
    INITIATE_ASSIGNMENT_EDITS: 'Click Initiate Assignment Edits',
    SAVE_CREATED_ASSIGNMENT: 'Click Save Created Assignment',
    SAVE_ASSIGNMENT_EDITS: 'Save assignment edits',
    SAVE_CREATED_ASSIGNMENTS: 'Save created assignments',
    OPEN_BULK_ASSIGNMENT_EDIT_OPTIONS: 'Open Bulk Assignment Edit Options',
    CLICK_CONFIRM_SYLLABUS: 'Click Confirm Syllabus',
    CLICK_OPEN_ASSIGNMENT: 'Click Open Assignment',
    HOVER_PERFORMANCE_GRAPH: 'Hover Performance Graph',
    HOVER_ON_PERFORMANCE_REPORT_GRAPH: 'Hover on Performance Report Graph',
    HOVER_COMPLETION_LABEL: 'Hover Completion Label',
    CLICK_OPEN_ASSIGNMENT_AS_STUDENT: 'Click Open Assignment As Student',
    VIEW_SPECIFIC_STUDENT_INSIGHTS: 'View Specific Student Insights',
    VIEW_COURSE_ASSIGNMENT_INSIGHTS: 'View Course Assignment Insights',
    VIEW_QUESTION_REMEDIATION_OPTIONS: 'View Question Remediation Options',
    SELECT_QUESTION_REMEDIATION_OPTION: 'Select Question Remediation Option',
    TOGGLE_COURSE_RESOURCE: 'Toggle Course Resource',
    OPEN_PREFERENCE_SETTING_MODAL: 'Open Course Resource Settings',
    VIEW_DIFFICULT_TOPICS: 'View Difficult Topics',
    VIEW_STRUGGLING_STUDENTS: 'View Struggling Students',
    OPEN_SPECIFIC_QUESTION_INSIGHTS: 'Open Specific Question Insights',
    OPEN_SPECIFIC_STUDENT_INSIGHTS: 'Open Specific Student Insights',
    VIEW_SPECIFIC_ASSIGNMENT_STUDENT_INSIGHTS: 'View Specific Assignment Student Insights',
    VIEW_ASSIGNMENT_INSIGHTS: 'View Assignment Insights',
    TOGGLE_DIFFICULT_QUESTIONS: 'Toggle Difficult Questions',
    TOGGLE_STRUGGLING_STUDENTS: 'Toggle Struggling Students',
    START_QUESTION_ISSUE_REPORT: 'Start Question Issue Report',
    SUBMIT_QUESTION_ISSUE_REPORT: 'Submit Question Issue Report',
    SWITCH_P_PLUS_COURSE: 'Switch P+ Course',
    OPEN_P_PLUS_COURSE_LIBRARY: 'Open P+ Course Library',
    VIEW_P_PLUS_COURSE_LIBRARY: 'View P+ Course Library',
    OPEN_P_PLUS_SWITCHER: 'Open P+ Course Switcher',
    SORT_PERSONAL_P_PLUS_LIBRARY: 'Sort Personal P+ Library',
    SEARCH_PERSONAL_P_PLUS_LIBRARY: 'Search Personal P+ Library',
    INITIATE_COURSE_CREATION: 'Initiate Course Creation',
    CANCEL_COURSE_CREATION: 'Cancel Course Creation',
    NAVIGATE_TO_PREVIOUS_STEP: 'Navigate To Previous Step',
    VIEW_COURSE_CREATION_FORM: 'View Course Creation Form',
    COMPLETE_COURSE_CREATION: 'Complete Course Creation',
    COPY_EXISTING_COURSE: 'Copy Existing Course',
    COPY_OTHER_INSTRUCTOR_COURSE: 'Copy Other Instructor Course',
    SEARCH_ETEXT_CATALOG: 'Search Etext Catalog',
    OPEN_COURSE_MANAGEMENT_OPTIONS_LIST: 'Open Course Management Options List',
    OPEN_INVITE_STUDENTS_OPTIONS: 'Open Invite Students Options',
    CLOSE_INVITE_STUDENTS_OPTIONS: 'Close Invite Students Options',
    COPY_INVITE_STUDENTS_LINK: 'Copy Invite Students Link',
    COPY_INVITE_STUDENTS_INSTRUCTIONS: 'Copy Invite Students Instructions',
    COPY_COURSE_CODE: 'Copy Course Code',
    OPEN_COURSE_ROSTER: 'Open Course Roster',
    SEARCH_COURSE_ROSTER: 'Search Course Roster',
    SORT_COURSE_ROSTER_SEARCH_RESULTS: 'Sort Course Roster Search Results',
    SAVE_CHANGES_TO_COURSE_SETTINGS: 'Save Changes To Course Settings',
    CANCEL_CHANGES_TO_COURSE_SETTINGS: 'Cancel Changes To Course Settings',
    DROP_STUDENTS_FROM_COURSE: 'Drop Students From Course',
    INITIATE_CHANGE_USER_COURSE_ROLE: 'Initiate Change User Course Role',
    CHANGE_USER_ENROLLMENT_STATUS: 'Change User Enrollment Status',
    EXPORT_COURSE_DATA: 'Export Course Data',
    VIEW_TEMPORARY_ACCESS_NOTIFICATION: 'View Temporary Access Notification',
    CLOSE_TEMPORARY_ACCESS_NOTIFICATION: 'Close Temporary Access Notification',
    NAVIGATE_PRODUCT_DETAIL_PAGE: 'Navigate Product Detail Page',
    INITIATE_EMAIL_TO_STUDENTS: 'Initiate Email To Students'
  },
  QUESTION_TYPE: {
    MCQ: 'MCQ'
  },
  ASSIGNMENT_STATUS_EVENT_LABEL: {
    [PROGRESS_STATUS.COMPLETED]: 'complete',
    [PROGRESS_STATUS.COMPLETED_LATE]: 'complete',
    [PROGRESS_STATUS.IN_PROGRESS]: 'inprogress',
    [PROGRESS_STATUS.NOT_STARTED]: 'new'
  },
  ASSIGNMENT_STATUS_CUSTOM_FIELD: {
    [PROGRESS_STATUS.COMPLETED]: 'completed',
    [PROGRESS_STATUS.COMPLETED_LATE]: 'completed',
    [PROGRESS_STATUS.IN_PROGRESS]: 'in_progress',
    [PROGRESS_STATUS.NOT_STARTED]: 'not_started'
  },
  TAB_EVENT_ACTION: {
    UP_NEXT_INSIGHTS_TAB: 'View Up Next Insights Tab',
    ASSIGNMENTS_INSIGHTS_TAB: 'View Assignments Insights Tab',
    STUDENT_ROSTER_INSIGHTS_TAB: 'View Students Insights Tab',
    UP_NEXT: 'View Up Next Insights Tab',
    ASSIGNMENTS: 'View Assignments Insights Tab',
    REVIEW: 'View Review Insights Tab'
  },
  FLOW_STEP: {
    SCHEDULE: 'assignment_scheduling',
    REVIEW: 'adding_assignment_content'
  },
  COMMAND_SOURCE_CODE: {
    DRAG: 'drag'
  },
  ADD_CONTENT_EVENT_LABEL: {
    CHAPTER: 'chapter',
    SUBCHAPTER: 'subchapter',
    COMBINATION: 'combination'
  },
  INITIATE_POINT: {
    UP_NEXT_INSIGHTS_TAB: 'up_next_tab',
    ASSIGNMENTS_INSIGHTS_TAB: 'assignment_tab',
    STUDENT_ROSTER_INSIGHTS_TAB: 'student_tab',
    BULK_ASSIGNMENT_DELETE: 'bulk_assignment_delete',
    ASSIGNMENT_PAGE_DELETE: 'assignment_page_delete',
    EDIT_ASSIGNMENT_DELETE: 'edit_assignment_delete',
    UP_NEXT_TAB_DELETE: 'up_next_tab_delete',
    UPLOAD_SYLLABUS: 'upload_syllabus',
    ADD_MANUALLY: 'add_manually',
    ASSISTED_SETUP: 'assisted_setup',
    BULK_EDIT: 'bulk_edit',
    EMPTY_STATE: 'empty_state',
    ADD_ASSIGNMENT: 'add_assignment',
    EDIT_ASSIGNMENT: 'edit_assignment'
  },
  LOCATION_IN_APP: {
    ASSIGNMENT_PAGE_L1: 'assignment_page_l1',
    ASSIGNMENT_PAGE_L2: 'assignment_page_l2',
    STUDENT_PAGE_L2: 'student_page_l2',
    ASSIGNMENTS_PAGE: 'assignments_page',
    EDUCATOR_AET: 'educator_aet',
    STUDENT_AET: 'student_aet',
    UP_NEXT_AET: 'upnext_aet',
    REVIEW_AET: 'review_aet',
    SUGGESTED_REVIEW_UP_NEXT_AET: 'suggested_review_upnext_aet',
    SUGGESTED_REVIEW_REVIEW_AET: 'suggested_review_review_aet',
    ASSIGNMENTS_AET: 'assignments_aet',
    ASSIGNMENT_AET: 'assignment_aet',
    UPLOAD_SYLLABUS: 'upload_syllabus',
    ASSIGNMENTS_DUE_NEXT: 'assignments_due_next',
    ASSIGNMENT_DETAILS: 'assignment_details',
    ASSIGNMENT_STUDENT_DETAIL: 'assignment_student_detail',
    ASSIGNMENT_QUESTION_DETAIL: 'assignment_question_detail',
    PPLUS_COURSE_HOME: 'pplus_course_home',
    PPLUS_COURSE_LIST_CURRENT: 'pplus_course_list_current',
    PPLUS_COURSE_HOME_HEADER: 'pplus_course_home_header',
    PPLUS_COURSE_HOME_CM_OPTIONS: 'pplus_course_home_cm_options',
    COURSE_SETTINGS: 'course_settings',
    MANAGE_ROSTER: 'manage_roster',
    COURSE_HOME_STUDENT_INSIGHTS: 'course_home_student_insights',
    PPLUS_CREATE_COPY_COURSE: 'pplus_create_copy_course',
    PPLUS_CREATE_COURSE_FORM: 'pplus_course_creation_form',
    PPLUS_COPY_COURSE_FORM: 'pplus_course_copy_form',
    PPLUS_INVITE_STUDENTS_MODAL: 'pplus_invite_students_modal',
    PPLUS_COURSE_SETTINGS_FORM: 'pplus_course_settings_form',
    PPLUS_MANAGE_ROSTER: 'pplus_manage_roster',
    PPLUS_ASSIGNMENT_SETTINGS: 'pplus_assignment_settings'

  }
};
export const NOT_SELECTED_SCHOOL = 'NOT_SELECTED_SCHOOL';
export const CHANNEL_PARTNER = 'channel_partner';
export const BOOKSTORE_TITLE_ADDED = 'bookStoreTitleAdded';
export const BOOKSTORE_SURVEY = 'bookstoreSurvey';
export const ASSESSMENT = 'assessment';
export const ASSET = 'asset';
export const ASSET_FETCHED = 'ASSET_FETCHED';
export const ASSET_REQUESTED = 'ASSET_REQUESTED';
export const ASSET_FAILED = 'ASSET_FAILED';
export const AUDIO_BOOK_REQUESTED = 'AUDIO_BOOK_REQUESTED';
export const AUDIO_FLAG_ON = 'On';
export const AUDIO_FLAG_ON_BETA = 'On/Beta';
export const AUTH_VERIFIED = 'AUTH_VERIFIED';
export const AUTOBAHN_TIMEONTASK = 'AUTOBAHN_TIMEONTASK';
export const BACK_LINK_REQUESTED = 'BACK_LINK_REQUESTED';
export const BOOK = 'Book';
export const BOOKSHELF_DATA_FETCHED = 'BOOKSHELF_DATA_FETCHED';
export const BOOKSHELF_DATA_REQUESTED = 'BOOKSHELF_DATA_REQUESTED';
export const BUNDLED_PLATFORM = 'ETEXT2';
export const CG_RENEWALS = 'CG_renewals';
export const CHAPTER = 'Chapter';
export const COLLECTIONS = 'Collections';
export const COLLECTION_CLIENT_APP = 'ETEXT2_WEB';
export const CONTACT_SUPPORT = 'CONTACT SUPPORT';
export const CONTENT_TYPE_CITE = 'CITE';
export const CONTENT_TYPE_EPUB = 'EPUB';
export const CONTENT_TYPE_EPUB3 = 'EPUB3';
export const CONTENT_TYPE_BV_BRONTE = 'VIEWER';
export const CONTENT_TYPE_BV_VIEWER = 'BRONTE_VIEWER';
export const CONTENT_TYPE_PDF = 'PDF';
export const CONTENT_TYPE_PXE = 'PXE';
export const ETEXT_BV_BRONTE = 'ETEXT_BV_BRONTE';
export const CONTENT_TYPE_SPDF = 'SPDF';
export const BRONTE_EPUB = 'Bronte ePub';
export const COURSE = 'Course';
export const COURSE_COLLECTION_REQUESTED = 'COURSE_COLLECTION_REQUESTED';
export const COURSE_DATA_FETCHED = 'COURSE_DATA_FETCHED';
export const COURSE_SYNC_REQUESTED = 'COURSE_SYNC_REQUESTED';
export const COURSE_WARE = 'courseWare';
export const CSG_APP_ID_PDF = 'etext1';
export const CUSTOM = 'custom';
export const CUSTOM_COLLECTIONS = 'CUSTOM_COLLECTIONS';
export const CUSTOM_COURSE = 'CUSTOM_COURSE';
export const D2L_INTEGRATED_RENEWAL = 'D2L Integrated Renewal';
export const D2L_STANDALONE = 'D2L Standalone';
export const D2L_STANDALONE_RENEWAL = 'D2L Standalone Renewal';
export const DEFAULT_BOOK_COVER = '/default-book-cover.png';
export const DEFAULT_LOCALE = 'en';
export const DEFAULT_LOCALE_US = 'en-us';
export const DIRECT_TO_LEARNER = 'directToLearner';
export const DIRECT_TO_LEARNER_RENEWAL = 'directToLearnerRenewal';
export const DIRECT_TO_CONSUMER = 'directToConsumerSubscription';
export const DIRECT_TO_CONSUMER_IA = 'directToConsumerIA';
export const DIRECT_TO_CONSUMER_HEI = 'directToConsumerHEI';
export const DIRECT_TO_CONSUMER_PERPETUAL = 'directToConsumerPerpetual';
export const DIRECT_TO_CONSUMER_HEIUK = 'directToConsumerHEIUK';
export const DIRECT_TO_CONSUMER_HEICA = 'directToConsumerHEICA';
export const DIRECT_TO_CONSUMER_HEILATAM = 'directToConsumerHEILATAM';
export const INSTRUCTOR_LED_SAET = 'instructorLedSAeT';
export const INSTRUCTOR_LED_SAETIA = 'instructorLedSAeTIA';
export const INSTRUCTOR_LED_SAET_K12 = 'instructorLedSAeTK12';
export const INSTRUCTOR_LED_SAET_IA_K12 = 'instructorLedSAeTIAK12';
export const PEARSON_PLUS_HEIUK = 'Pearson+ HEIUK';
export const PEARSON_PLUS_HEICA = 'Pearson+ HEICA';
export const PEARSON_PLUS_HEILATAM = 'Pearson+ HEILATAM';
export const PEARSON_PLUS_HEI = 'Pearson+ HEI';
export const IL_SAET = 'IL SAeT';
export const IL_SAET_IA = 'IL SAeT IA';
export const INCLUSIVE_ACCESS_DISPLAY_NAME = 'Pearson+ Inclusive Access';
export const ETEXT_CDN_TOKEN = 'etext-cdn-token';
export const INTEGRATED_SMS = 'IntegratedSMS';
export const INTEGRATED_RUMBA = 'IntegratedRumba';
export const INTEGRATED_SMS_ETEXT = 'Integrated SMS eText';
export const INTEGRATED_RUMBA_ETEXT = 'Integrated Rumba eText';
export const PEARSON_PLUS_MULTI = 'Pearson+ Multi';
export const PEARSON_PLUS_ETEXTBOOK = 'Pearson+ eTextbook';
export const PEARSON_PLUS_LIFETIME = 'Pearson+ Lifetime';
export const INTEGRATED_ETEXT_3L = 'Integrated eText 3PL';
export const MOJO_US_SINGLE = 'BASIC';
export const BRONTE_VIEWER = 'Bronte Viewer';
export const HRS = ' hrs';
export const MIN = ' min';
export const BUNDLE_SINGLE = 'BUNDLE_SINGLE';
export const BUNDLE = 'BUNDLE';
export const DIGITAL_SAMPLE_REP = 'digitalSampleRep';
export const DIGITAL_SAMPLE_SELF = 'digitalSampleSelf';
export const DIGITAL_SAMPLE_MARKETING = 'digitalSampleMarketing';
export const BOOKSTORE_USER = 'p.com';
export const SAMPLE_FROM_REP = 'Sample from Rep';
export const SAMPLE_FROM_SELF = 'Self-requested Sample';
export const SAMPLE_FROM_MARKETING = 'Marketing Sample';
export const PEARSON_PLUS_LIFETIME_ACCESS = 'Pearson+ Lifetime Access';
export const INSTRUCTOR_LED_ETEXTBOOK_COURSE = 'Instructor-led eTextbook course';
export const K12_INSTRUCTOR_LED_ETEXTBOOK_COURSE = 'K-12 Instructor-led eTextbook course';
export const DIGITAL_SAMPLE_SELF_REQUESTED = 'Digital Sample - self requested';
export const DIGITAL_SAMPLE_FROM_SALES_REP = 'Digital Sample from sales rep';
export const ETEXTBOOK_FOR_MLM_COURSE = 'eTextbook for MyLab Mastering course';
export const ETEXTBOOK_RENEWAL_FROM_MLM_COURSE = 'eTextbook renewal from MyLab Mastering course';
export const CONTENT_LEARNING_MODE = 'Learn';
export const DND_TYPE = 'TableOfContents';
export const SEND_OTP = 'sendmfa';
export const RESEND_OTP = 'resendmfa';
export const DRAWER_PANEL_CONTENT = 'Contents';
export const LD_PRODUCT_KEY = 'e-text';
export const LD_ENABLE_WANT_MORE = 'enableWantMore';
export const DRAWER_STATE_CLOSED = 'closed';
export const DRAWER_STATE_OPEN = 'open';
export const DROP_LEVEL_TYPE = 'WITH_IN_SAME_LEVEL';
export const EPUB_BRONTE = 'ETEXT_EPUB_BRONTE';
export const EPUB_BRONTE_STANDARD = 'ETEXT_EPUB_STANDARD';
export const ETEXT_PDF = 'ETEXT_PDF';
export const FOXIT = 'FOXIT';
export const FOXIT_LOGO = 'https://d38l3k3yaet8r2.cloudfront.net/etextpdfresources/foxitassets/hotspot_icons/foxit-logo.png';
export const FR_FR = 'fr-fr';
export const FR_CA = 'fr-ca';
export const GET_LOOSE_LEAF = 'GET LOOSE LEAF';
export const GLOSSARY = 'glossary';
export const GLOSSARY_HOTSPOT_FETCHED = 'GLOSSARY_HOTSPOT_FETCHED';
export const GLOSSARY_HOTSPOT_REQUESTED = 'GLOSSARY_HOTSPOT_REQUESTED';
export const GTM_REQUESTED = 'GTM_REQUESTED';
export const INTEGRATED_ETEXT = 'Integrated eText';
export const JA = 'ja';
export const JA_JP = 'ja_jp';
export const KO = 'ko';
export const KO_KR = 'ko_kr';
export const MARIN = 'marin';
export const MS_IN_AN_HOUR = 60 * 60 * 1000;
export const MS_IN_A_DAY = 24 * MS_IN_AN_HOUR;
export const NOTES_COPY_REQUESTED = 'NOTES_COPY_REQUESTED';
export const ODD = 'O';
export const PAGE_SEQUENCE_ASSET_REQUESTED = 'PAGE_SEQUENCE_ASSET_REQUESTED';
export const PDF_CLIENT_APP = 'ETEXT1_WEB';
export const IES_DEVICE_LIST_REQUESTED = 'IES_DEVICE_LIST_REQUESTED';
export const DEVICE_LIST_REQUEST_SUCCESS = 'DEVICE_LIST_REQUEST_SUCCESS';
export const DEVICE_SWAP_SUCCESS = 'DEVICE_SWAP_SUCCESS';
export const DEVICE_VIOLATION_SUCCESS = 'DEVICE_VIOLATION_SUCCESS';
export const DEVICE_OTP_VALIDATE_SUCCESS = 'DEVICE_OTP_VALIDATE_SUCCESS';
export const DEVICE_OTP_VALIDATE_FAILURE = 'DEVICE_OTP_VALIDATE_FAILURE';
export const DEVICE_REGISTER_SUCCESS = 'DEVICE_REGISTER_SUCCESS';
export const GPC_PREFERENCE_CREATE = 'PREFERENCE_CREATE';
export const PREFERENCE_SUCCESS = 'PREFERENCE_SUCCESS';
export const PREFERENCE_FAILURE = 'PREFERENCE_FAILURE';
export const USER_PREFERENCE = 'USER_PREFERENCE';
export const REMOVE_ENTITLEMENT = 'REMOVE_ENTITLEMENT';
export const REMOVE_ENTITLEMENT_SUCCESS = 'REMOVE_ENTITLEMENT_SUCCESS';
export const REMOVE_ENTITLEMENT_FAILURE = 'REMOVE_ENTITLEMENT_FAILURE';
export const THREAT_STATUS_SUCCESS = 'THREAT_STATUS_SUCCESS';
export const AUTHHOME_APPLICATION = 'Application';
export const AUTHHOME_APPLICATION_EVENT_ACTION = 'Load Authenticated Home';
export const AUTHHOME_APPLICATION_EVENT_NAME = 'loadauthenticatedhome';
export const SMART_THINKING = 'Smarthinking';
export const MLM_LAUNCH_EREADER = 'custom_mediaOpenMode';
export const MLM_LAUNCH_URL_PARAM = 'launchURL'; // temp
export const PDF_CONSTANTS = {
  FILE_FORMAT: {
    FLV_FORMAT: 'flv',
    SWF_FORMAT: 'swf'
  },
  LINK_TYPE: {
    AUDIO_TEXT_SYNCH: 10,
    CHROMELESS_URL: 15,
    EMAIL: 8,
    FACELESSAUDIO: 12,
    FLV: 2,
    GLOSSARY_TERM: 3,
    H264: 13,
    IMAGE: 1,
    IPADAPP: 14,
    JAZZASSET: 16,
    LTILINK: 11,
    MP3: 4,
    PAGE_NUMBER: 5,
    SWF: 6,
    URL: 7,
    VIRTUAL_LEARNING_ASSET: 9
  },
  REGION_TYPE: {
    AUDIO: 1,
    CROSS_REFERENCE: 2,
    EMAIL: 3,
    EXCEL: 13,
    FLASH: 4,
    GLOSSARY_TERM: 5,
    IMAGE: 6,
    INDEX_LINK: 7,
    IPADAPP: 17,
    JAZZASSET: 18,
    LTILINK: 16,
    MEDIA: 8,
    PDF: 14,
    POWERPOINT: 9,
    TOC_LINK: 10,
    URL: 11,
    VIDEO: 12,
    WORD_DOC: 15
  },
  USER_ROLE: {
    DEFAULT_ROLE: 'all',
    DEFAULT_ROLE_ID: 1,
    EDUCATOR: 'educator',
    INSTRUCTOR: 'instructor',
    INSTRUCTOR_ID: 3,
    STUDENT: 'student',
    STUDENT_ID: 2
  }
};
export const PDF_COVER_PAGE = 'Cover';
export const PDF_HOTSPOT_FETCHED = 'PDF_HOTSPOT_FETCHED';
export const PDF_HOTSPOT_REQUESTED = 'PDF_HOTSPOT_REQUESTED';
export const PLAYLIST_CHAPTER = 'chapter';
export const PLAYLIST_SLATE = 'slate';
export const POP = 'POP';
export const PRIVACY_POLICY = 'PRIVACY POLICY';
export const PRODUCT_DATA_FETCHED = 'PRODUCT_DATA_FETCHED';
export const PRODUCT_SYNC_REQUESTED = 'PRODUCT_SYNC_REQUESTED';
export const PRODUCT_TOKEN_REQUESTED = 'PRODUCT_TOKEN_REQUESTED';
export const STANDALONE_ETEXT = 'IL Standalone eText';
export const STANDARDS = 'standards';
export const SLATE = 'slate';
export const USER_ROLE_STUDENT = 'student';
export const USER_LOADS_CONTENT = 'UserLoadsContent';
export const USER_UNLOADS_CONTENT = 'UserUnloadsContent';
export const AUTHORIZATION = 'authorization';
export const X_AUTHORIZATION = 'x-authorization';
export const ERROR_CODE_MARIN = 'ETEXT001';
export const ERROR_CODE_PRISM = 'ETEXT002';
export const ERROR_CODE_ETEXT = 'ETEXT003';
export const ERROR_CODE_IDC = 'ETEXT004';
export const ERROR_CODE_STPAPER = 'ETEXT005';
export const ERROR_SUPPORT = 'ERROR_SUPPORT';
export const ERROR_SUPPORT_CLICK = 'ERROR_SUPPORT_CLICK';
export const TITLE = 'Pearson eTextbook';
export const TELEMTRY_INIT = 'inittelemetry';
export const TELEMETRY_USER = 'usertelemetry';
export const PRODUCT_PLATFORM = 'ILP';
export const PRODUCT_MODEL = 'Etext';
export const TELEMETRY_PAGE_ACTION = 'telemetrypageaction';
export const TELEMETRY_PAGE_ERROR = 'telemetrypageerror';
export const TELEMETRY_PAGE_LOAD = 'loadcontent';
export const TELEMETRY_PAGE_UNLOAD = 'unloadcontent';
export const ID_TYPE = 'PI';
export const PRODUCT_ROLE = 'Learner';
export const ORGANIZATION_ID_TYPE = 'Organization';
export const PEARSON_SUBSCRIPTION_TIER_CODE = 'Basic';
export const NOT_APPLICABLE = 'NA';
export const CONTENT_TYPE = 'Read';
export const PLAYER_MODE_CODE = 'READING'; // TOTO Need to remove and use it dynamically from spectrum
export const NAVIGATION = 'navigation';
export const EVENT_ACTION = 'Next'; // TOTO - Need to remove and use it from vega reader
export const LASTLOCATION_DATA_REQUESTED = 'LASTLOCATION_DATA_REQUESTED';
export const LASTLOCATION_DATA_FETCHED = 'LASTLOCATION_DATA_FETCHED';
export const DISCONNECT_DEVICE = 'disconnectdevice';
export const ETEXT_BOOK_SOURCE = 'sms,rumba';
export const MOJO_BOOK_SOURCE = 'passport';
export const ACCOUNT_SETTING = 'accountsettings';
export const ACCOUNT_LOCK_SUCCESS = 'ACCOUNT_LOCK_SUCCESS';
export const LOCK_ACCOUNT_EVENT_ACTION = 'Lock Account';
export const LOCK_ACCOUNT_EVENT_NAME = 'lockaccountforthreatlevel2';
export const LOCK_ACCOUNT_EVENT_LABEL = 'Threat Level 2';
export const PAGE_VIEW = 'pageview';
export const READ = 'read';
export const AUDIO = 'audio';
export const STUDY = 'study';
export const BOOKMARK = 'bookmark';
export const SOCIAL = 'social';
export const DRAWER_PANEL_AUDIO = 'Audio';
export const DRAWER_PANEL_CHANNELS = 'Channels';
export const DRAWER_PANEL_STUDY = 'Study';
export const DRAWER_PANEL_SOCIAL = 'SocialPost';
export const DRAWER_PANEL_BOOKMARK = 'Bookmarks';
export const DRAWER_PANEL_NOTEBOOK = 'Notebook';
export const DRAWER_PANEL_SERACH = 'Search';
export const DRAWER_PANEL_ASK_AI = 'aitutor';
export const STANDARD = 'STANDARD';
export const STANDARD_THEME = 'standard';
export const ACTIVE = 'ACTIVE';
export const EXPIRED = 'EXPIRED';
export const MOJO_US_MULTI = 'MOJO_US_MULTI';
export const MOJO_HOME = 'Mojo Home';
export const ACCESSIBILITY = 'accessibility';
export const ACCESSIBILITY_BTN_ID = 'accessibility-expand-collapse';
export const ACCESSIBILITY_ARIA_LABEL = 'Accessibility';
export const ACCESSIBILITY_SUPPORT = 'Accessibility support';
export const CHAT_WITH_SUPPORT = 'chatwithsupport';
export const DEVICES = 'devices';
export const DEVICE_BTN_ID = 'help-expand-collapse';
export const DEVICE_ARIA_LABEL = 'Devices';
export const FAQS = 'faqs';
export const USER_DETAILS = 'userdetails';
export const HELP_SUPPORT = 'helpsupport';
export const HELP_SUPPORT_BTN_ID = 'help-expand-collapse';
export const HELP_SUPPORT_ARIA_LABEL = 'Help & Support';
export const LEGAL = 'legal';
export const LEGAL_BTN_ID = 'legal-expand-collapse';
export const LEGAL_ARIA_LABEL = 'Legal';
export const PEARSON_ACCESSIBILITY = 'Pearson accessibility';
export const PRINT_PAGE = 'printpage';
export const QR_CODE = 'appinfoWithQR';
export const SIGN_OUT = 'signout';
export const SUPPORT = 'support';
export const TERMS_OF_USE = 'termsofuse';
export const PRIVACY_NOTICE = 'privacynotice';
export const APP_INFO = 'appinfo';
export const TITLE_INFO = 'titleinfo';
export const TITLE_INFO_ARIA_LABEL = 'Title Info';
export const MOJO = 'MOJO';
export const NONMOJO = 'NONMOJO';
export const SIGN_OUT_EVENT = 'Sign Out';
export const PRINT_PAGE_EVENT = 'Print Page';
export const GET_THE_APP_EVENT = 'Click Get The App';
export const HELP_SUPPORT_EVENT = 'Click Help And Support';
export const FAQS_EVENT = 'Click FAQs';
export const SUPPORT_EVENT = 'Click Support';
export const CHAT_WITH_SUPPORT_EVENT = 'Click Chat With Us';
export const DEVICES_EVENT = 'Click Devices';
export const LEGAL_EVENT = 'Click Legal';
export const TERMS_OF_USE_EVENT = 'Click Terms of Use';
export const PRIVACY_NOTICE_EVENT = 'Click Privacy Policy';
export const ACCESSIBILITY_EVENT = 'Click Accessibility';
export const PEARSON_ACCESSIBILITY_EVENT = 'Click Pearson Accessibility';
export const ACCESSIBILITY_SUPPORT_EVENT = 'Click Accessibility Support';
export const TITLE_INFO_EVENT = 'Click Title Info';
export const USER_PROFILE_FETCHED = 'USER_PROFILE_FETCHED';
export const COURSE_TYPE_SMS = 'SMS';
export const COURSE_TYPE_REGISTRAR = 'Registrar';
export const LOAD = 'load';
export const UNLOAD = 'unload';
export const PLUS = 'plus';
export const PLUS_PPE = 'plus-ppe';
export const ETEXT = 'etext-ise';
export const ETEXT_PERF = 'etext-ise-perf';
export const CP = 'cp';
export const TPI = 'isTpi';
export const LOCAL = 'local-dev';
export const PEARSONED_DOMAIN = '.pearson.com';
export const GPC_PREFERENCE_RETRIEVE_SUCCESS = 'GPC_PREFERENCE_RETRIEVE_SUCCESS';
export const PEARSON_PLUS_META = 'Reimagined learning, designed for you';
export const PEARSON_ETEXT_META = 'Let the learning begin!';
export const PEARSON_PLUS_TITLE = 'Pearson+';
export const PEARSON_ETEXT_TITLE = 'Pearson eTextbook';
export const SHOW_DEVICE_MANAGEMENT_POPUP = false;
export const SIGN_IN_REDIRECT_URL = 'https://www.pearson.com/en-us.html';
export const SIGN_IN = 'sign_in';
export const LAUNCH_STUDY_EVENT = 'launchstudy';
export const LAUNCH_STUDY_EVENT_ACTION = 'Launch Study';
export const LAUNCH_STUDY_EVENT_LABEL = 'Launch From: Bookshelf';
export const BOOKSHELF = 'Bookshelf';
export const PAUSED = 'PAUSED';
export const DEVICE_EXPIRED = 'EXPIRED';
export const DEVICE_INCORRECT = 'INCORRECT';
export const DEVICE_MANY_ATTEMPTS = 'MANY ATTEMPTS';
export const OTPCODE = 'otpcodes';
export const OTPCODE_BTN_ID = 'otpcodes-expand-collapse';
export const OTPCODE_ARIA_LABEL = 'OTP codes';
export const LAUNCH_CODE = 'launchcodelog';
export const SEND_CODE = 'sendnewcode';
export const SEND_CODE_PHONE = 'sendnewcodetxtmsg';
export const LAUNCH_LOG_REQUESTED = 'LAUNCH_LOG_REQUESTED';
export const LAUNCH_LOG_FETCHED = 'LAUNCH_LOG_FETCHED';
export const OTPREQUESTED = 'OTPRequested';
export const LINK_SUCCESS_MODAL = 'clicklinkinmfasuccessmodal';
export const OTP_LINK_MODAL = 'clicklinkinotpmodal';
export const SUBMIT_CODE = 'submitmfacode';
export const CON_SESSION_MODAL = 'Concurrent Sessions Modal';
export const CLICK_RESEND_MFA = 'Click Resend MFA';
export const SUBMIT_MFA_CODE = 'Submit MFA Code';
export const OTP_MODAL = 'OTP Modal';
export const CLICK_LINK = 'Click Link';
export const MFA_SUCCESS_MODAL = 'MFA Success Modal';
export const TOO_MANY_ATTEMPTS = 'Too Many Attempts';
export const BACK_TO_HOME = 'Back to Home';
export const RESEND_MFA_CODE = 'Resend MFA Code';
export const CLOSE = 'Close';
export const CONTACT_CUST_SUPPORT = 'Contact Customer Support';
export const PEARSON_FAQ = 'Pearson+ FAQ';
export const OTP_EXPIRED = 'Expired';
export const VALID = 'Valid';
export const INVALID = 'Invalid';
export const CHANGE_PASSWORD = 'Change Password';
export const UPDATE_EMAIL = 'Update Your Email';
export const CONCURRENT_SESSIONS_MODAL_EVENT = 'Concurrent Sessions Modal';
export const RESPOND_TO_WARNING = 'Respond to Warning';
export const DISMISS_EVENT_LABEL = 'Dismiss';
export const LATER_EVENT_LABEL = 'Maybe later';
export const PASSWORD_EVENT_LABEL = 'Change password';
export const CONCURRENT_SESSIONS_EVENT_NAME = 'concurrentsessionsmodal';
export const PMC_USER_PROFILE_TOKEN = 'pmcUserProfileToken';
export const PMC_USER_PROFILE = 'pmcUserProfile';
export const PMC_USER_PROFILE_SUCCESS = 'pmcUserProfileSuccess';
export const PMC_USER_PROFILE_FAIL = 'pmcUserProfileFail';
export const LOAD_ERROR = 'Load error';
export const LOAD_ERROR_NAME = 'loaderror';
export const LOAD_ERROR_LABEL = 'Can\'t access Etextbook';
export const TL2_CATEGORY = 'OTP Modal';
export const TL2_EVENT_NAME = 'clickacceptinotpmodal';
export const TL2_EVENT_ACTION = 'Click Accept';
export const TL2_EVENT_LABEL = 'Okay';
export const PPLUS_CUSTOMER_SUPPORT = 'https://support.pearson.com/getsupport/s/';
export const NON_PPLUS_CUSTOMER_SUPPORT = 'https://support.pearson.com/getsupport/s/contactsupport';
export const AUTH_HOME = 'AUTH_HOME';
export const MLM_AUTH_HOME = 'MLM_AUTH_HOME';
export const ALL_AUTH_HOME = 'ALL_AUTH_HOME';
export const EREADER = 'EREADER';
export const ACCOUNT_SETTINGS_MYACCOUNT = 'My account';
export const ACCOUNT_SETTINGS_CHANGE_PASSWORD = 'Change password';
export const ACCOUNT_SETTINGS_RESET_PASSWORD = 'Reset password';
export const ACCOUNT_SETTINGS_PREFERENCES_CENTER = 'Preferences center';
export const ACCOUNT_SETTINGS_HELP_CENTER = 'Help center';
export const ACCOUNT_SETTINGS_SIGNOUT = 'Sign out';
export const ACCOUNT_SETTINGS = 'accountsettings';
export const ACCOUNT_SETTINGS_CATEGORY = 'Account Settings';
export const ACCOUNT_SETTINGS_ACTION = 'Select Menu Option';
export const PEARSON_LOGO = 'Pearson Logo';
export const EDUCATOR = 'educator';
export const TEMPLATE_LABEL = {
  MARKETING_TEMPLATE: 'empty_state',
  BOOK: 'etext_only',
  CHANNEL: 'channels_only',
  BOOK_WITH_CHANNEL: 'etext_mappedchannel',
  ETEXT_RELATED_CHANNEL: 'etext_relatedchannel',
  ETEXT_MAPPEDCHANNEL_LITE: 'etext_mappedchannel_lite',
  EDUCATOR_AET_EMPTY_STATE: 'Educator_AeT_Empty_State',
  EDUCATOR_AET_ASSIGNMENTS: 'Educator_AeT_assignments',
  EDUCATOR_AET: 'Educator_AeT',
  STUDENT_AET: 'Student_AeT'
};
export const AET_TEMPLATE_LABEL = {
  EDUCATOR_AET_EMPTY_STATE: 'EDUCATOR_AET_EMPTY_STATE',
  EDUCATOR_AET_ASSIGNMENTS: 'EDUCATOR_AET_ASSIGNMENTS',
  EDUCATOR_AET: 'EDUCATOR_AET',
  STUDENT_AET: 'STUDENT_AET'
};
// Display order constants
export const DISPLAY_ORDER_CONTENT_REQUESTED = 'DISPLAY_ORDER_CONTENT_REQUESTED';
export const DISPLAY_ORDER_CONTENT_SUCCESS = 'DISPLAY_ORDER_CONTENT_SUCCESS';
export const ENTITLEMENTLEVEL_MULTI = 'MULTI';
export const ENTITLEMENTLEVEL_SINGLE = 'SINGLE';
export const ENTITLEMENTLEVEL_STUDY = 'STUDY';
export const SEARCH_EVENT = {
  EVENT_NAME: 'dashboardnavtitlesevent',
  EVENT_ACTION: 'Sort Bookshelf',
  EVENT_CATEGORY: 'Dashboard Navigation - Integrated Titles'
};
export const BOOK_EVENT = {
  EVENT_ACTION: 'Select Title',
  EVENT_NAME: 'dashboardnavigation'
};
export const PRODUCT_MAPPING_REQUESTED = 'PRODUCT_MAPPING_REQUESTED';
export const PRODUCT_MAPPING_FETCHED = 'PRODUCT_MAPPING_FETCHED';
export const PRODUCT_MAPPING_FAILED = 'PRODUCT_MAPPING_FAILED';
export const USER_PREFERENCES_SUCESS = 'USER_PREFERENCES_SUCESS';
export const USER_PREFERENCES_REQUESTED = 'USER_PREFERENCES_REQUESTED';
export const USER_PREFERENCES_FAIL = 'USER_PREFERENCES_FAIL';
export const USER_BOOK_PREFERENCES_REQUESTED = 'USER_BOOK_PREFERENCES_REQUESTED';

// Footer
export const FOOTER = 'Footer';
export const FOOTER_EVENT = 'clicklinkinfooter';

// Caurosel

export const AUTH_HOME_CATEGORY = 'Auth Home';
export const EREADER_CATEGORY = 'eReader';
export const EREADER_ACTION_ACCESS_ETEXT = 'Access eText';

export const CLICK = 'click';
export const SEARCH = 'Search';
export const DOTS = 'Dots';

export const BRAZE_TARGET_AREA = {
  AUTHHOME_HEADER_BANNER: 'AUTHHOME_HEADER_BANNER',
  AUTHHOME_HERO_BANNER: 'AUTHHOME_HERO_BANNER',
  AUTHHOME_HEADER_NOTIFICATION: 'AUTHHOME_HEADER_NOTIFICATION'
};
export const COMMON_CONTAINERS = [
  '.Hero-dashboard-section-container',
  '.library-container',
  '.Channel-container',
  '.turbo-container',
  '.procourse-container',
  '.mondly-container'
];
export const BANNERS = {
  CODE_REDEEMED: {
    id: 'one-reader-codeRedeemed',
    click_event_action: 'Click on code redeemed card',
    view_event_action: 'View code redeemed card',
    event_label: 'code_redeemed'
  }
};
export const NATIVE_APP_BANNER_CLASS = {
  BANNER: 'one-reader-native-app-banner',
  DRAWER: 'one-reader-native-app-drawer'
};
export const MARKETING_CARD_ID = 'one-reader-hero-book-marketing-card';
export const QR_CODE_CARD = 'QR_CODE_CARD_';
export const QR_CODE_VARIANT = {
  V1: 'v1',
  V2: 'v2',
  V3: 'v3',
  V4: 'v4',
  V5: 'v5',
  V6: 'v6',
  DEFAULT: ''
};
export const QR_COMPONENT_IDS = {
  QR_CODE_BUTTON: 'QR_CODE_BUTTON',
  QR_CODE_ICON: 'QR_CODE_ICON',
  QR_CODE_CARD_V1: `${QR_CODE_CARD}${QR_CODE_VARIANT.V1}`,
  QR_CODE_CARD_V2: `${QR_CODE_CARD}${QR_CODE_VARIANT.V2}`,
  QR_CODE_CARD_V3: `${QR_CODE_CARD}${QR_CODE_VARIANT.V3}`,
  QR_CODE_CARD_V4: `${QR_CODE_CARD}${QR_CODE_VARIANT.V4}`,
  QR_CODE_CARD_V5: `${QR_CODE_CARD}${QR_CODE_VARIANT.V5}`,
  QR_CODE_CARD_V6: `${QR_CODE_CARD}${QR_CODE_VARIANT.V6}`
};
export const QR_CODE_CARD_COMPONENT_IDS = [
  QR_COMPONENT_IDS.QR_CODE_CARD_V1,
  QR_COMPONENT_IDS.QR_CODE_CARD_V2,
  QR_COMPONENT_IDS.QR_CODE_CARD_V3,
  QR_COMPONENT_IDS.QR_CODE_CARD_V4,
  QR_COMPONENT_IDS.QR_CODE_CARD_V5,
  QR_COMPONENT_IDS.QR_CODE_CARD_V6
];
export const REMEDIATION_CONTAINER_COMPONENT_ID = 'REMEDIATION_CONTAINER';
export const REVIEW_REMEDIATION_CONTAINER_COMPONENT_ID = 'REVIEW_REMEDIATION_CONTAINER';
export const DIFFICULT_QUESTIONS_CONTAINER_COMPONENT_ID = 'DIFFICULT_QUESTIONS_CONTAINER';
export const STRUGGLING_STUDENTS_CONTAINER_COMPONENT_ID = 'STRUGGLING_STUDENTS_CONTAINER';
// Scroll Eventing
export const TRACKING_CONTAINERS = [
  ...COMMON_CONTAINERS,
  '#one-reader-hero-mappedchannel',
  '.one-reader-hero-mappedchannel',
  '.library-l2-container',
  '.Channel-l2-container',
  '[data-componentId="LEARN_ASSETS_CONTAINER"]',
  '[data-componentId="PRACTICE_ASSETS_CONTAINER"]',
  '[data-componentId="SUBSCRIPTION_STATUS"]',
  '[data-componentId="HIGHLIGHT_PROMO_COL2"]',
  '[data-componentId="UPLOAD_SYLLABUS_CARD"]',
  '[data-componentId="POPULAR_CHANNELS_SLIDER"]',
  '[data-componentId="POPULAR_CHANNELS_EMPTY_STATE"]',
  '[data-componentId="RELATED_CHANNEL"]',
  '[data-componentId="HIGHLIGHT_PROMO_TOP"]',
  `#${BRAZE_TARGET_AREA.AUTHHOME_HEADER_BANNER}`,
  `#${BRAZE_TARGET_AREA.AUTHHOME_HERO_BANNER}`,
  `#${BANNERS.CODE_REDEEMED.id}`,
  `#${MARKETING_CARD_ID}`,
  `[data-componentid="${QR_COMPONENT_IDS.QR_CODE_CARD_V1}"]`,
  `[data-componentid="${QR_COMPONENT_IDS.QR_CODE_CARD_V2}"]`,
  `[data-componentid="${QR_COMPONENT_IDS.QR_CODE_CARD_V3}"]`,
  `[data-componentid="${QR_COMPONENT_IDS.QR_CODE_CARD_V4}"]`,
  `[data-componentid="${QR_COMPONENT_IDS.QR_CODE_CARD_V5}"]`,
  `[data-componentid="${QR_COMPONENT_IDS.QR_CODE_CARD_V6}"]`,
  '[data-componentid="REMEDIATION_CONTAINER"]',
  '[data-componentid="REVIEW_REMEDIATION_CONTAINER"]',
  `[data-componentid="${DIFFICULT_QUESTIONS_CONTAINER_COMPONENT_ID}"]`,
  `[data-componentid="${STRUGGLING_STUDENTS_CONTAINER_COMPONENT_ID}"]`
];
export const AUTH_HOME_SCROLL_EVENT = 'Auth Home';
export const USER_CONTAINER = 'userseescontainer';
export const USER_SEES_CONTAINER = 'User Sees Container';

export const EVENT_AUTHHOMEEVENT = 'authhomeevent';
export const EVENT_EREADEREVENT = 'ereaderevent';
export const FACULTY_OR_INSTRUCTOR = 'FACULTY_OR_INSTRUCTOR';
export const LIBRARY_EVENT = {
  EVENT_CATEGORY: 'Auth Home',
  REMOVE_ICON_EVENT_LABEL: 'Delete',
  LOCATION: {
    AUTHHOME: 'Authenticated Home',
    LIBRARYL2: 'LibraryL2'
  },
  EVENT_ACTION_ETEXT: 'Launch ETEXT',
  EVENT_LABEL_ETEXT: 'Launch from: Auth Home',
  ETEXT_OPEN_BOOK_EVENT_LABEL: 'open_etextbook',
  ETEXT_EXPIRED_REACTIVATE_EVENT_LABEL: 'expired_renew',
  ETEXT_PAUSED_REACTIVATE_EVENT_LABEL: 'paused_reactivate',
  ETEXT_PRINT_COMPANION_EVENT_LABEL: 'print_upsell',
  EXEXT_CONTINUE_READING_EVENT_LABEL: 'continue_reading',
  EXEXT_VIEW_ETEXTBOOK_EVENT_LABEL: 'view_eTextbook',
  ETEXT_FEATURE_ELEMENT_CLICK_EVENT_ACTION: 'Click Textbook Feature Element',
  ETEXT_CLICK_EVENT_ACTION: 'Click eTextbook Element',
  BOOKMARK_EVENT_LABEL: 'Bookmarks',
  AUDIO_EVENT_LABEL: 'Audiobook',
  FLASHCARD_EVENT_LABEL: 'Flashcards',
  CONTENT_EVENT_LABEL: 'TOC',
  GOTOPAGE_EVENT_LABEL: 'go_to_page',
  SEARCH_EVENT_LABEL: 'Search',
  NOTES_EVENT_LABEL: 'Notes_Highlights',
  INFO_EVENT_LABEL: 'Info',
  TOC_EVENT_LABEL: 'TOC',
  INFO: {
    OPEN: 'Info.Open',
    CONTINUE_READING: 'Info.ContinueReading',
    REMOVE_FROM_LIBRARY: 'Info.RemoveFromLibrary'
  }
};
export const ADD_TITLE_EVENT_LABEL = 'Add Title';
export const ADD_TITLE_EVENT_LABELV1 = 'add_title';
export const ETEXT_CONTENT_CARD = 'eText_content_card';
export const SWAPTITLE_REMAIN_DAYS = 21;
export const DEFAULT_RENDER_ORDER = ['heroView', 'library', 'channel', 'mondly', 'turbo', 'procourse'];
export const LIBRARY_ICON_TOOLTIP_CONTEXT = {
  channel: 'Channels',
  social: 'Start a discussion'
};

// Bookshelf - newly added tag duration
export const NEW_BOOK_MAX_DAYS = 30;
export const EXPIRED_BOOK_MAX_DAYS = 31;
export const GLOBAL_NAV_MENU_BAR = {
  EVENT_LABEL: {
    LIBRARY: 'Library',
    CHANNELS: 'Channels',
    LANGUAGES: 'Languages'
  }
};
export const LD_COMPONENTS_NAME = {
  MONDLY: 'enableMondlyLangComponent',
  TURBO: 'enableTurboComponent',
  ITPRO: 'enableProCourseComponent',
  MONDLY_MARKETING: 'showHEIUserContent'
};
export const COLLEGE_STUDENT_UNDERGRADUATE = 'COLLEGE_STUDENT_UNDERGRADUATE';
export const HIGH_SCHOOL_STUDENT = 'HIGH_SCHOOL_STUDENT';
export const MINIMUM_TURBO_ELIGIBLE_AGE = 18;
export const MARQUEE_GROUP_0 = 'default';
export const MARQUEE_GROUP_1 = 'group1';
export const MARQUEE_GROUP_3 = 'group3';
export const DEFAULT_TEMPLATE = 'default';
export const VARIANT_A = 'variantA';
export const VARIANT_B = 'variantB';
export const VARIANT_C = 'variantC';
export const MARQUEE_VARIATION = {
  [MARQUEE_GROUP_0]: 'baseline',
  [MARQUEE_GROUP_1]: 'marquee_container_122022_A',
  [MARQUEE_GROUP_3]: 'marquee_container_122022_B'
};
export const DEFAULT_CONTAINER_DATA = {
  library: {
    title: 'Library',
    subText: 'Your textbooks upgraded.',
    noTitleSubText: 'Add a title to get started.',
    description: 'Search, add notes & highlights, use flashcards, and personalize your reading experience.',
    seeAllTitle: 'See all'
  }
};
export const ENTERKEY = 'Enter';
export const SPACEKEY = 'Space';
export const SPACE = ' ';
export const TABLET_BREAKPOINT_834 = 834;
export const TABLET_BREAKPOINT_1024 = 1024;
export const TABLET_BREAKPOINT_768 = 768;
export const DESKTOP_BREAKPOINT_1280 = 1280;
export const LD_EVENT_NAME = {
  LIBRARY_SECTION_CLICK: 'LibrarySectionClick',
  TITLE_CARD_CLICK: 'TitleCardClick',
  LIBRARY_OPEN_CHANNEL_CLICK: 'LibrarySectionOpenChannelClick',
  CHANNEL_L1_CARD_CLICK: 'ChannelClicked',
  HERO_CHANNEL_CARD_CLICK: 'HeroChannelCardClick',
  CLICK_CHANNEL_CARD_ELEMENT: 'ClickChannelCardElement',
  HERO_HIGHLIGHT_PROMO_CARD_CLICK: 'ClickChannelHighlightCardElement',
  CLICK_PUBLISH_ALL_ASSIGNMENTS: 'ClickPublishAllAssignments',
  CLICK_ONBOARDING_ADD_MANUALLY: 'ClickOnboardingAddManually',
  CLICK_ONBOARDING_AUTO_CREATE: 'ClickOnboardingAutoCreateAssignments',
  CLICK_ONBOARDING_LEARN_MORE: 'ClickOnboardingLearnMore'
};
export const NO_LOCATION_FOUND = 'No location Found for the given bookId';
export const MLM_IA_LAUNCH = 'MLM_IA_LAUNCH';
export const PPLUS_LAUNCH_SUCCEEDED = 'PPLUS_LAUNCH_SUCCEEDED';
export const SEARCH_BAR_UTM_PARAM = 'utm_source=authhome&utm_medium=webapp&utm_campaign=search&utm_content=searchbar';
export const IS_KEYBOARDCLICK = 'isKeyboardClicked';
export const L2PAGE = 'L2PAGE';
export const L2_SEPERATOR = '~!~';
export const LIBRARY = 'library';
export const CHANNEL = 'channel';
export const SWAP_TITLE = 'swapTitle';
export const AUTO_RENEWAL = 'autoRenewal';
export const DATE_FORMAT = 'MMM DD, YYYY';
export const YEAR_MONTH_DAY_FORMAT = 'yyyy-mm-dd';
export const MONTH_DAY_YEAR_FORMAT = 'MM/dd/yyyy';
export const IS_ENROLLMENT = 'isEnrollment';
export const IS_CONSOLE = 'isConsole';
export const IS_LMS = 'isLMS';
export const LMS = 'lms';
export const REDIRECTURL = 'redirectURL';
export const SUBSCRIPTION_BANNER = {
  SWITCHTITLE: 'switchTitle',
  AUTORENEWALCREDITCARD: 'autoRenewalCreditCard',
  AUTORENEWALBOOKSTORE: 'autoRenewalBookStore',
  PAUSED: 'paused',
  EXPIRED: 'expired'
};
export const SWAP_TITLE_PERIODS = {
  LAST21: 'last21',
  FIRST14: 'first14'
};
export const IA_QUERY_PARAMS = {
  REF: 'ref',
  ISIA: 'isIA',
  PRODUCTID: 'productID'
};
export const LOGO_EVENT_ACTION = 'Click P+ Icon';
export const LOCATION_IN_APP = {
  ONBOARDING: 'onboarding',
  ADD_COURSE_CTA: 'add_course_cta',
  NEW_OTHER_COURSE_CONTAINER: 'new_other_course_container',
  NEW_MOST_RELATED_CONTAINER: 'new_most_related_container',
  NEW_OTHER_COURSE_CONTAINER_RELATED: 'new_other_course_container_related',
  NEW_OTHER_COURSE_CONTAINER_UNRELATED: 'new_other_course_container_unrelated',
  AUTHHOME: 'AuthHome',
  CHANNELS_CATALOG: 'Channels Catalog',
  PPLUS_AUTHHOME: 'P+ Auth Home',
  HERO: 'Hero',
  HERO_RECENTCHANNEL: 'Hero_recentchannel',
  HERO_NORECENTCHANNEL_NOACTIVETEXTBOOK: 'Hero_norecentchannel_noactivetextbook',
  MESSAGE_CENTER: 'MessageCenter',
  LIBRARY: 'Library',
  LIBRARYL2: 'LibraryL2',
  LIBRARY_L2: 'library_l2',
  MAPPEDHERO_SOL1D_CONTROL: 'MappedHero_Sol1D_control',
  CHANNELS: 'Channels',
  CHANNEL: 'Channel',
  CHANNELL2: 'Channel L2',
  MAPPED_CHANNEL_HERO: 'MappedChannelHero',
  MAPPED_CHANNEL_LIBRARY: 'MappedChannelLibrary',
  INFO: 'Info',
  HERO_ETEXT_MAPPED_CHANNEL: 'Hero_eText_Mapped Channel',
  COURSE_TAB: 'course_tab',
  MORE_AT_PEARSON: 'more_at_pearson',
  EXAMPREP_CONTAINER: 'examprep_container',
  HOME2: 'Home2',
  HOME1: 'Home1',
  HOME2_FLOATING: 'Home2_floating',
  HOME2_TEXTINPUT: 'Home2_textinput',
  HOME2_CARD: 'Home2_card',
  AI_TUTOR_CARD: 'AI_Tutor_card',
  PRACTICE: 'practice',
  TAILORED_EXAM_CARD: 'tailored_exam_card',
  AH_UPNEXT: 'AH_upNext',
  AH_ASSIGNMENTLIST: 'AH_assignmentlist',
  UP_NEXT_TAB: 'up_next tab',
  REVIEW_TAB: 'review_tab',
  ASSIGNMENT_TAB: 'assignment_tab',
  STUDENTS_PAGE: 'students_page',
  AH_REVIEW: 'AH_review'
};
export const GET_HELP = 'Get help';
export const INCLUSIVE_ACCESS = 'inclusive_access';
export const BOOK_STORE = 'bookstore';
export const IA = 'IA';
export const TOPIC_TIMEOUT = 10000;
export const DELAY_TIMER_IN_SECS = 60000;
export const HERO_BANNER_TYPES = {
  BOOK: 'BOOK',
  BOOK_WITH_CHANNEL: 'BOOK_WITH_CHANNEL',
  CHANNEL: 'CHANNEL',
  MARKETING_TEMPLATE: 'MARKETING_TEMPLATE'
};
export const ACTIVITY_TYPE = {
  AUDIO: 'audio',
  BOOKMARK: 'bookmark',
  READ: 'read',
  STUDY: 'study',
  INFO: 'info',
  NOTES: 'notes',
  SEARCH: 'search',
  CONTENTS: 'contents',
  REMOVE_FROM_COURSE: 'removeFromCourse'
};
export const BOOK_ICON_HOLDER = {
  AUDIO_ICON: 'AudioIcon',
  BOOKMARK_ICON: 'BookmarkIcon',
  FLASHCARD_ICON: 'FlashcardIcon',
  INFO_ICON: 'TitleInfoIcon',
  DELETE_ICON: 'DeleteIcon'
};
export const PEARSON_SESSION = 'PEARSON_SESSION';
export const CHAPTER_ID_QUERY_PARAM = 'chapterId';
export const INITIATE_POINT_QUERY_PARAM = 'initiatePoint';
export const L2PAGE_CHANNEL_URL = 'L2PAGE~!~ChannelsExpanded';
export const TOC_SEPERATOR_CHAPTER = '!@#!';
export const CHANNEL_EVENT = {
  OPEN_CHANNEL_EVENT_LABEL: 'OpenChannel',
  CLICK_CHANNEL_CARD_ELEMENT: 'Click Channel Card Element'
};
export const MESSAGE_CENTER_AND_SUBSCRIPTION_BANNER_EVENTS = {
  CTA_CLICK: 'Click Message Element'
};
export const MESSAGE_CENTER_AND_SUBSCRIPTION_BANNER_EVENT_LABEL = {
  codeRedeemed_oneOrMoreTitles_existingUser: 'Existing_CodeRedeemed_SearchTitle',
  letsgetgoing_newUser: 'New_LetsGetGoing_SearchTitle',
  letsgetgoing_channelsPaid_noChannel_newUser: 'New_Welcome_ViewChannels',
  letsgetgoing_channelsPaid_channel_newUser: 'New_Welcome_ViewChannelsActivation',
  letsgetgoing_channelsPaid_noChannel_existingUser: 'Existing_Welcome_ViewChannels',
  letsgetgoing_channelsPaid_channel_existingUser: 'Existing_Welcome_ViewChannelsActivation',
  digitalSample_multi_newUser: 'New_Welcome_ViewLibraryDigitalSample',
  digitalSample_single_newUser: 'New_Welcome_ViewLibraryDigitalSample',
  digitalSample_multi_existingUser: 'Existing_Welcome_ViewLibraryDigitalSample',
  digitalSample_single_existingUser: 'Existing_Welcome_ViewLibraryDigitalSample',
  oneTitle_existingUser_digitalsample: 'Existing_Welcome_ViewLibraryDigitalSample',
  switchTitle: 'Info.Exchange',
  autoRenewalBookStore: 'Info.AutoRenewBSExtend',
  autoRenewalCreditCard: 'Info.AutoRenewCCExtend',
  oneTitle_existingUser: 'Existing_NeedMoreTitles_SearchTitle',
  playStore: 'PlayStore',
  appStore: 'AppStore',
  paused: 'Info.PausedReactivate',
  expired: 'Info.ExpiredRenew',
  study_channel: 'study_help'
};
export const BOOK_VIEW_EVENT_ACTION = 'View Library Card';
export const ETEXT_BOOK_LABEL = 'e-Textbook';
export const SOURCE_OF_EREADER_LAUNCH = {
  AUTHHOME: 'Auth Home',
  CONSOLE: 'Console Web',
  DIRECT: 'Direct Login Specific Title Web',
  DEEPLINK: 'Deeplink Web'
};
export const AUDIO_QUERY_SELECTOR = {
  HERO: '[data-hero-audio="true"]',
  LIBRARY: '[data-library-audio="true"]'
};
export const EREADER_UTM_SOURCE = 'utm_source=ereader';
export const URL_QUERY_START_INDICATOR = '?';
export const URL_QUERY_SEPARATOR = '&';
export const LIVE = 'LIVE';
export const REVIEW = 'REVIEW';
export const OFF = 'OFF';
export const ON = 'ON';
export const OFF_DISABLED = 'OFF_DISABLED';
export const MARKETING_CARD_IMAGE_URL = '/assets/images/marketingCardCoverImage.png';
export const PRACTICE_SET_ICON = '/assets/images/practiceSetIcon.png';
export const CONCEPT_THUMBNAIL = '/assets/images/conceptThumbnailV1.png';
export const MARKETING_CARD_CTA_TYPES = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary'
};
export const LIBRARY_CARDS_LIMIT = 4;
export const MAPPED_CHANNEL_TEMPLATES = {
  MAPPEDCHANNELASSET: {
    ICONS: {
      STACKICON: 'StackIcon',
      LISTICON: 'ListIcon',
      PLAYICON: 'PlayIcon'
    }
  },
  MAPPED_CHANNEL_ASSET_CARD: {
    TEXT: 'MappedChannelAssetCard'
  },
  POPULAR_CHANNEL_ASSETS_CARD: {
    TEXT: 'PopularChannelAssetCard'
  },
  LAST_ACCESSED_CHANNEL_ASSETS: {
    TEXT: 'lastAccessedChannelAssets'
  }
};
// Channel constants
export const CHANNEL_RECOMMENDATIONS_BY_BOOK_REQUESTED = 'CHANNEL_RECOMMENDATIONS_BY_BOOK_REQUESTED';
export const CHANNEL_REMEDIATION_BY_BOOK_REQUESTED = 'CHANNEL_REMEDIATION_BY_BOOK_REQUESTED';
export const CHANNEL_REMEDIATION_BY_BOOK_SUCCESS = 'CHANNEL_REMEDIATION_BY_BOOK_SUCCESS';
export const CHANNEL_REMEDIATION_BY_BOOK_FAILED = 'CHANNEL_REMEDIATION_BY_BOOK_FAILED';
export const CHANNEL_RECOMMENDATIONS_BY_BOOK_SUCCESS = 'CHANNEL_RECOMMENDATIONS_BY_BOOK_SUCCESS';
export const CHANNEL_RECOMMENDATIONS_BY_BOOK_FETCHED = 'CHANNEL_RECOMMENDATIONS_BY_BOOK_FETCHED';
export const CHANNEL_RECOMMENDATIONS_BY_CHANNEL_REQUESTED = 'CHANNEL_RECOMMENDATIONS_BY_CHANNEL_REQUESTED';
export const CHANNEL_RECOMMENDATIONS_BY_CHANNEL_SUCCESS = 'CHANNEL_RECOMMENDATIONS_BY_CHANNEL_SUCCESS';
export const CHANNEL_RECOMMENDATIONS_BY_CHANNEL_FETCHED = 'CHANNEL_RECOMMENDATIONS_BY_CHANNEL_FETCHED';
export const CHANNEL_TYPES = {
  EXAM_PREP: 'EXAM_PREP',
  RECOMMENDED_ASSETS: 'recommendedAssets',
  START_WITH_TOPICS: 'startWithTopics',
  POPULAR_TOPICS: 'popularTopics',
  JUMPBACK_IN_AND_RECOMMENDED_NEXT: 'jumpBackInAndRecommendedNext'
};
export const ASSET_CONTENT_TYPE = {
  MULTIPLE_CHOICE: 'multiple-choice',
  SIMPLE_QUESTIONS: 'simple-questions',
  EXAMPLE: 'example',
  TEXT_BLOCK: 'text-block',
  IMAGE: 'image',
  CONCEPT: 'concept',
  AUDIO: 'audio',
  VIDEO_STREAM: 'video-stream'
};
export const ASSET_CONTENT_TYPE_DISPLAY_TEXT = {
  [ASSET_CONTENT_TYPE.MULTIPLE_CHOICE]: 'Multiple choice',
  [ASSET_CONTENT_TYPE.SIMPLE_QUESTIONS]: 'Simple questions'
};
export const FETCH_HERO_MAPPED_CHANNEL = 'fetchHeroMappedChannel';
export const BRAZE_IDENTIFY_USER = 'BRAZE_IDENTIFY_USER';
export const BRAZE_TRIGGER_EVENT = 'BRAZE_TRIGGER_EVENT';
export const BRAZE_IN_APP_MESSAGE_CARD_FETCHED = 'BRAZE_IN_APP_MESSAGE_CARD_FETCHED';
export const BRAZE_CUSTOM_EVENTS = {
  SHOW_MAPPED_CHANNEL_CAMPAIGN: 'showMappedChannelCampaign',
  PPLUS_WEB_EREADER_LOADED: 'PPLUS_WEB_EREADER_LOADED',
  PPLUS_WEB_AH_LOADED: 'PPLUS_WEB_AH_LOADED'
};
export const TEMPLATE_A = 'templateA';
export const TEMPLATE_B = 'templateB';
export const TEMPLATE_C = 'templateC';
export const TEMPLATE_E = 'templateE';
export const TEMPLATE_D = 'templateD';
export const TEMPLATE_F = 'templateF';
export const TEMPLATE_G = 'templateG';
export const TEMPLATE_H = 'templateH';
export const CENTER = 'CENTER';
export const BOTTOMRIGHT = 'BOTTOMRIGHT';
export const TOPRIGHT = 'TOPRIGHT';
export const BRAZE_CONTENT_CARD_FETCHED = 'BRAZE_CONTENT_CARD_FETCHED';
export const BRAZE_IN_APP_FETCHED = 'BRAZE_IN_APP_FETCHED';
export const TEMPLATE_V1 = 'TemplateV1';
export const BRAZE_MARKETING_CONTENT_CARD = 'brazeMarketingContentCard';
export const BRAZE_AUTHHOME_BANNER = 'brazeAuthhomeBanner';
export const BRAZE_CONTENT_CARD_FOR_VIEW_IMPRESSION = [
  BRAZE_TARGET_AREA.AUTHHOME_HEADER_BANNER,
  BRAZE_TARGET_AREA.AUTHHOME_HERO_BANNER
];
export const MESSAGE_CENTER = 'MESSAGE_CENTER';
export const CHANNEL_MARKETING_CARD1 = '/assets/images/channelMarketingCard1.png';
export const CHANNEL_MARKETING_CARD2 = '/assets/images/channelMarketingCard2.png';
export const CHANNEL_MARKETING_CARD3 = '/assets/images/channelMarketingCard3.png';
export const POPULAR_CHANNELS_REQUESTED = 'POPULAR_CHANNELS_REQUESTED';
export const CHANNEL_DETAILS_REQUESTED = 'CHANNEL_DETAILS_REQUESTED';
export const CHANNEL_PERSONALIZED_VALUES = {
  RECENT_CHANNEL: 'recent_channel',
  MARKETING_CARD: 'marketing_card',
  RECOMMENDED__ASSETS: 'recommended_assets',
  POPULAR_ASSETS: 'popular_assets',
  CHANNEL_BANNER: 'channel_banner',
  POPULAR_CHANNEL: 'popular_channel',
  CHANNEL_FEATURES_LEARN_MORE: 'channel_features_learn_more'
};
export const CHANNEL_MARKETING_IMAGE_TYPE = {
  NORMAL: 'normal',
  EXTENDED: 'extended'
};
export const CHANNEL_BYBOOK_MAX_ASSET_A = 'CHANNEL_BYBOOK_MAX_ASSET_A';
export const CHANNEL_BYBOOK_MAX_ASSET_B = 'CHANNEL_BYBOOK_MAX_ASSET_B';
export const BYCHANNEL_MAX_ASSET = 'CHANNEL_BYCHANNEL_MAX_ASSET';
export const POPULAR_CHANNEL_BYBOOK_MAX_ASSET = 'POPULAR_CHANNEL_BYBOOK_MAX_ASSET';
export const CHANNEL_TYPE_RESPONSE = {
  PRACTICE_SET: 'Practice Set',
  TOPIC: 'Topic'
};
export const CHANNEL_SECTION_FILTERS = {
  ALL: 'All'
};
export const CHANNEL_QUERY_PARAM = 'CEP=plusAuthHP';
export const CHANNEL_ASSET_QUERY_PARAM = 'CEP=plusAuthHP_Asset';
export const CHANNEL_CHANNEL_QUERY_PARAM = 'CEP=plusAuthHP_Channel';
export const CHANNEL_SECTION_QUERY_PARAM = 'CEP=plusAuthHP_Section';
export const STUDY_EXAM_PREP_SUBSCRIPTION_STATUS_PARAM = 'CEP=plusAuthHP_Resources';
export const CHANNELS_CONTAINER_PARAM = 'CEP=plusAuthHP_ChannelsContainer';
export const CHANNEL_GET_UNSTUCK = 'CEP=plusAuthHP_GetUnstuck';
export const CHANNEL_ASSET_PRATICE_QUERY_PARAM = 'CEP=plusAuthHP_Practice';

export const TRUE = 'true';
export const BRAZE_LOCATION_IN_APP = {
  PPLUS_WEB_AUTHHOME: 'PPLUS_WEB_AUTHHOME',
  PPLUS_WEB_EREADER: 'PPLUS_WEB_EREADER'
};
export const BRAZE_CTA_ACTION = {
  COPYURL: 'COPYURL'
};
export const BRAZE_NO_DATA = '-NA-';
export const NATIVE_APP_PROMO_TYPES = {
  DRAWER: 'drawer',
  BANNER: 'banner',
  MODAL: 'modal'
};
export const NATIVE_APP_BANNER_EVENTS = {
  EVENT_NAME: 'user_interaction',
  EVENT_ACTION: 'click native app banner',
  VIEW_EVENT_ACTION: 'View native app banner',
  VIEW_EVENT_LABEL: {
    BOTTOM_DRAWER: 'Bottom Drawer',
    BANNER: 'Banner'
  },
  EVENT_LABEL: {
    BOTTOM_DRAWER_CONTINUE: 'Bottom Drawer - Continue',
    [NATIVE_APP_PROMO_TYPES.DRAWER]: 'Bottom Drawer - Open App',
    [NATIVE_APP_PROMO_TYPES.BANNER]: 'Banner - Open App',
    BANNER_CLOSE: 'Banner - Close'
  },
  NEW_EVENT_LABEL: {
    [NATIVE_APP_PROMO_TYPES.BANNER]: {
      INSTALL: 'bottom_banner_install',
      CLOSE: 'bottom_banner_close'
    },
    [NATIVE_APP_PROMO_TYPES.DRAWER]: {
      INSTALL: 'bottom_sheet_install',
      CLOSE: 'bottom_sheet_close'
    },
    [NATIVE_APP_PROMO_TYPES.MODAL]: {
      INSTALL: 'modal_install',
      CLOSE: 'modal_close'
    }
  }
};
export const BOOKSHELF_USER_COLLECTIONS = {
  ARCHIVED: 'Archived'
};
export const COURSE_COLLECTION_SERVICE_REQUESTED = 'COURSE_COLLECTION_SERVICE_REQUESTED';
export const COURSE_COLLECTION_SERVICE_FETCHED = 'COURSE_COLLECTION_SERVICE_FETCHED';
export const COURSE_COLLECTION_SERVICE_FAILED = 'COURSE_COLLECTION_SERVICE_FAILED';
export const BOOK_COLLECTION_SERVICE_REQUESTED = 'BOOK_COLLECTION_SERVICE_REQUESTED';
export const BOOK_COLLECTION_SERVICE_FETCHED = 'BOOK_COLLECTION_SERVICE_FETCHED';
export const BOOK_COLLECTION_SERVICE_FAILED = 'BOOK_COLLECTION_SERVICE_FAILED';
export const INVITE_SERVICE_REQUESTED = 'INVITE_SERVICE_REQUESTED';
export const INVITE_SERVICE_FETCHED = 'INVITE_SERVICE_FETCHED';
export const INVITE_SERVICE_FAILED = 'INVITE_SERVICE_FAILED';
export const HTTP_REQUEST_METHODS = {
  POST: 'POST',
  DELETE: 'DELETE',
  GET: 'GET',
  PATCH: 'PATCH',
  PUT: 'PUT'
};
export const LIBRARYL2_TABS = {
  MY_BOOKS: 'MY_BOOKS',
  ARCHIVED: 'ARCHIVED'
};
export const ARCHIVE_WHEN_USER_HAS_X_OR_MORE_TITLES = 6;
export const ARCHIVE_EVENTS = {
  CLICK_ARCHIVE_CTA: 'Click Archive CTA',
  CLICK_UNARCHIVE_CTA: 'Click Unarchive CTA',
  ARCHIVE: 'Archive',
  UNARCHIVE: 'Unarchive',
  VIEW_SELECT_TO_ARCHIVE_CTA: 'View select to archive CTA',
  VIEW_SELECT_TO_UNARCHIVE_CTA: 'View select to unarchive CTA',
  SELECT_TO_ARCHIVE: 'Select to archive',
  SELECT_TO_UNARCHIVE: 'Select to unarchive'
};
export const SELECT_TO_ARCHIVE_OR_UNARCHIVE_BUTTONS = {
  SELECT_TO_ARCHIVE: 'onereader-libraryl2-select-to-archive-cta',
  SELECT_TO_UNARCHIVE: 'onereader-libraryl2-select-to-unarchive-cta'
};
export const ELEMENTS_TO_TRACK_VIEWPORT_INTERSECTION = [
  `#${SELECT_TO_ARCHIVE_OR_UNARCHIVE_BUTTONS.SELECT_TO_ARCHIVE}`,
  `#${SELECT_TO_ARCHIVE_OR_UNARCHIVE_BUTTONS.SELECT_TO_UNARCHIVE}`,
  `.${NATIVE_APP_BANNER_CLASS.BANNER}`,
  `.${NATIVE_APP_BANNER_CLASS.DRAWER}`,
  '[data-componentId="NATIVE_APP_BOTTOM_BANNER"]',
  '[data-componentId="NATIVE_APP_BOTTOM_SHEET"]',
  '[data-componentId="NATIVE_APP_MODAL"]',
  `[data-componentId="${QR_COMPONENT_IDS.QR_CODE_BUTTON}"]`
];
export const EVENT_USER_INTERACTION = 'user_interaction';
export const OPEN_EREADER_COMPONENT = 'OPEN_EREADER_COMPONENT';
export const BRAZE_EREADER_COMPONENTS = {
  AI_CHATBOT: 'AI_CHATBOT',
  AUDIO: 'AUDIO',
  CHANNELS: 'CHANNELS',
  STUDY: 'STUDY',
  NOTEBOOK: 'NOTEBOOK'
};
export const AITutorLoaded = 'AITutorLoaded';
export const PENDO_PLATFORM = {
  [AUTH_HOME]: 'PPlus_Web_Auth_Home',
  [EREADER]: 'PPlus_Web_Ereader'
};
export const PRIMARY = 'primary';
export const SECONDARY_FILLED = 'secondary_filled';
export const DIVIDER = 'divider';
export const ASSET_CARD_SECTION_COLOR = {
  BLUE: '#045CAF',
  GREEN: '#006632',
  PINK: '#B20900',
  YELLOW: '#E49D2D',
  BG_CONCEPT: '#EBF5FF',
  BG_PRACTICE: '#EBF9F0',
  BG_EXAMPLE: '#FFE7E5'
};
export const USER_ACTION_AB_TEST_CLICK = 'User clicks on AB test variants';
export const BRAZE_STYLE_VARIANTS = {
  A: 'A'
};
export const CRUSH_YOUR_FINALS = 'Crush your finals';
export const AI_AUTO_OPEN = 'aiAutoOpen';
export const MAX_CHANNEL_CARD = 4;
export const NATIVE_APP_BANNER_DATA = {
  CTA_VARIANTS: {
    PRIMARY: 'primary',
    SECONDARY: 'secondary'
  },
  IDS: {
    open: 'open',
    continue: 'continue'
  },
  // eslint-disable-next-line max-len
  PEARSON_ICON: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAALQAAAC0CAMAAAAKE/YAAAADAFBMVEUNAE0AAEEOAE79/f7+/v78/P0QA0/////7+/wRBFAAAEAAAEIPAk79/f0RA1D+/v8BAEQAAEMPAU8FAEcJAEoOAE0QA1AQAk8GAEgJAEsLAEsMAE0IAEn9/P0MAEz+/f4EAEb8+/wDAEYCAEUHAEgDAEUOAk4PAU78+/0PA0/7+vwHAEkSBFEUCVMmGmDm5O0PCE7//v/n5u4ZDVbs6/ErIGP5+fsEAEcQBE/Rzt0JAkkAAD8WClQLAEzT0d/x8PVdVYiLhaoNBE2CfaP8/Pz5+PomH1/Z1+Pk4us/NXJGPHcbD1jf3edbVIdsZZP19Pfr6vA6MG6hnbpJQHl7dJ6gm7nPzNy0sMju7fJvZ5XBv9LJxtj29fj29vlQR34TBlF7d56fmbjNytoxKWcdF1nGxNYdElk8MnDk4+uEfqUkGF5eWImAe6LV0+A7NG6mo75RSn9NRHx2cJr6+vsgF1vFwdUWEFP4+PoSDFDc2eUUDVIgGVsgE1s3LGzv7vNEOXYvJGaYk7OcmLYIAEqOiKy1ssljW41mXo7Y1+NTSYDf3uj39/kuI2Xq6e82L2sLBEumor5XToQ3LmxZVIV8dZ8aEVeNh6uFf6Xy8fYRB1BBOnNpZJF+d6B5cp1XUYNkW41WToOUjrAAADobE1fd3OZhXItgWIpBN3NcU4fa2OStqMPQzdzj4uqopL/08/dLQXs9M3FzbJnFw9StqsNxbJeemrc5M21yapejn7zKx9nMydnDwdOZlLRxaZaCe6QtImWHg6eRjK7IxdcLAkw1K2szLGmppcBUTIJCPXTh4Onz8vbt7PKrp8K6tsy4tcsuJ2VqYZEiG1ywrMUwJmf8/f0sJmQAAD7o5+4pHWE9NnBnY48zKGlOR32Tja85MW1zb5i/u9BaUIawrcViWIu2s8lFO3alob1uZpSqpcFuapX+//6ysMc9N3C7uM2dmLe4tMrX1OIlHV68uM7Sz94oIWATBVE0KWokGV65tcx1bZkSClCfnLhIPnkzKWlPSX2UkbD7Hv/6AAANv0lEQVR42u1ceXwTVR7PnG/OZJJJ0zSkaZqkdyktZ6GAXAuCiNwCVkDKUeU+FgQEFBRwsaAgAoqAgAqKiHijooLgga4iuuq6Huuqq+K54rrrnm9yTJKZaTrAJO3uZ75/QM7mO7/3u3/vjcViwoQJEyZMmDBhwoQJEyZMmDBhwoQJEyZMmGheZKFhZP1vsEUd1TRdgvo8OU6nM8dn4UiaJgtbMOFCki5yBlgGEbyO1u0mT76oK50TflpmIWlHS5Q6RxeVsYi48cMe00b8dsLe+sGjRg1uO7Dzxw/0fGNARSsWCfhcJNqylIJGOyGdftj2/MHBQAP7px9/ZMYWlnWSZIuRt8PlRdzHxo/ZHGZIUBSRi2G4BIyHz/Lzwq/vHrphF2v30VxLoJztCLAnH5lEhPkSuJakcT6fkv5vmDlrCxNyOZpdytnB4IxHl0JGjRCWgVHSde3t3Zf1k81KG7UGhJdOw+Uncm2gaeAED8Dmb9faRWvz2aTViTx2GpLJx4FeYFBPSj+vQ1ZYm4dyUTYy8ToKig+cFfB8ANb8ZyLCNYeOWL3C3W2gYoCzhg1+5507/O7MC5tmFz8Mrc8GzgU4VJLvziCuzGp2Ecf8ux4QODhX4H3AqKmIJZMqku0p6A3FDM4HUEfuCjmzM8bZ5a58FfAYOD9AC35tvpgpxbYWTDxynmKOoBT8eLIgM6ytwpl+hnCWFGzhDxlhbQ2+faFBnMOsF4vp12tXwZkLQR8ADGPdfZGzKN1+IzRxbyo52zCYjFIEj0HwRL70GLOlZv2XUK/0ZtlFnsrLGuVs4ynt+EhQPJ7CGu9C6LQW2ZxwH/wVTfDha+H3jRlx5aA9Y4cN+Oyfs3es/HvPmQfr+bBEicZlvQdJpzHSzCZtzng40Zv+9NS61n6EQVi7AGG3IwjDiq3rLn7+0FxJ4NrixrATJ0Ppq2es7CxA4dr5Jhg5ba0PYcVuHE3T1WQE8CFZ5BFZxPv6Rwcl2prq3QfcIJSkreD2zmvA1XEQgwt/YvntOYzfQrs4dQ6Ewt4HKiLu9x69HIDcRhSETZeClAjfqTNRKZ0eOH4xEsyiHak7DAHk7eXFmsLG8N/8cjQ9HsSKvKF2HJDy6kGLYCHSdIRwWN3IjKcgRS1R38rQ6VGOn5dieSoxNzxSiXhoVNHI4xyOkhIHh6IKcQdD40s16gYMb9joTEdyTbKvKiMhVNDPFzO+OOUsqL7VnM9ZJvoLgsGCTmUe1JWkNdmFNS9dCIo1RD08HaIm7cOUIsoHS+9mvXRMGVHS5RNZ6OO4dj9fu2RK//5T3q/oGmIRaJ8JDq2cPXm/Wssw28At3YzX6sIuExSkKdD5dYSM5Q0k6WRZ7tpth29+am/D/ggr/JL6I0NHr/chYkKngxbn/1rLNv7IGi5qGvmTivOlVwfKY5RRgd214R+r45HHBrtiUcXv/lydPRCvB62hRRNUet0H/9ROGh2/W/XqZ+OTOV8hOl1RTS2yuwcMbYikGfkE7ONF/FoVngefwwcdj38Iu48ya/eu3UofYgO1FW7OaEFvTxYOBZ5mo2Upai0QZ42RCOdrJ3RSwCSumy/Iy0/bhyxQxnQCDDI8b1rX3UYk/cRQtjCy4KQPmfGN5P1SlOZV8M2Ft8dJldccVipIcdVpg/WDtI8FfBLnSaGjEROkg5W3FQOeaDrb79hD9mpZRyt343yyywcN7Yx11aT9TVuCweP45af8YbEUlTBf/whsetpMxFfgYjkFpWF0VXwpDwwQjBQ16q6oBbZEqY1gwn4jO0eYU6ryXzYc105B5/YviEb7LE/repCnWIo7DY0vNPJMErNcMDasf1bx6uPgq6Rlzou2qQlCqz0zcJEHjWXmHygulgJfsEZKmvN/XJVMYogIE+Bye9+Rim5e+FNzaxeElVRDr6+PKQgpDFB4PR50zjEwJhaWQe3Ak7L2HjvHkWjNDHUvoX75yv7PVnQYsuG0RjaHY/sryiJDxaycrm2TP4GDExcZaIku9p5kq8Hwfq8LQpe7L0l+Gc6FNs1H2KC7zO231wzVyOYSUtBs4W/JH7AB7P1OnIEqPUIhURtYM+b0dGVqnAvm7PTRrhKukHOMEzt0xFWhhsAnibJSX6/4oxgYZqT7OPo94BWeICJwxWv7uF5xUZUsVCsIDi64xotGJfFnBWkC9DDOEjl3h44qs8IJglc5h0nueK8ILbtMc0owJOCIpue3qDKw0cYFctL+onY9qiJ9JIQm+PZJGqRxsCyqAqTwoGIlDC0EaOawroYjAZ5MJO19UpP0vcEY6WEq0r2NIy3VWXpI54IJzgRH6+muNIQw679GPQRpn614nwJXGkca9U7QpR4wOnjiCbiP261liEuvWRFZjWq2h0qnjSON5nRto0gTGiM93Rf/lqf1PjVpHvzolJXuTlUc32oYac797gKgZ4yFgX5oK7nKzWnXVn2pFP5tzEHQyBUq0g8Z5j0cwQNA17QQA7tJn0zaeVF79aXy4MZYpo86RyqULh9sN4y0sgBIQfrlcrkNgHqvWaoijeG7t0QvCzr/BQpZ5Mav6PwzD1Ud3gjyQJvWOagcW36uVZFOCB80MlrpknBwIFhiWOYxWt9cCAfvtJNJa4VRAnReJ1uKqAyYOFhTYVibWm3mjZJuH88tOfEUoVh+DFuwPla5kMIyZdMYpi7jPFkZDohhJ+yNkXYEliiNkAdT5S40Kbym1DkCHBSLjIviV+ol/cpVZTLpggOgKlmfwSrZDVvZG1V2Ars/CN0MpNe8GyqURflZYmyB04LBs2RO6LpflB0EifTjSMbzJUi6tIPc2UpKLaSuyA194w1GGnlCY6QgJ4CGkL5VH2lYL10rxknviPLCCSjx6VMLQvJUpfx3D6n/orElorJ/kAov+B1JdSUeGYdO+H0ly3Fxzns0emgEGOM3skLcDvJ1ko6VJeEWEvWrMLP2M2fnID6XnEnRNdtKMVyj5t1kYK+GtN+oKzOVVri/HNLomq3wlc2dl188jxUsVtn/khZmkA3P00oCjOyKlQT7A1wn6fjvcqF75+y59yoPIu2KjSesdGDdXSBPa36amAMYkJqKz5bqY82DB+MZDyoybNBroRP2H6O0h1l7RHvaTNluNnJAjjrbNegjTURbfLH5G1mCJs3juiGLNi1oxKilmUu1kY3ebt315aYEuKWRxkWWgy4SmUVfDmxkzgyFMtjY7jQpXKovN5W6LS6tyTjZLYCIx557ubGJvqQdTxg7HVc3sBpBMViVEIjDWxA4i7OTnbGPmzL+KShiAkthDoZ21OEGzZUaM1bNCUXirIdlGMTut0z+145pnwwMv42lMOHVvVoZOxQPrMdt+kg/FI8PrUb3fP6KN8d8PzhiwxRhS/lNowf6unsICX2tLB85OL6DiWhisyRu23xVmcGHYbKDr+myRAocjpGGF1pPzaWKCV7PIsEZjuG7mGhmmi5LpEBPmbR33gVA955frHiJ3+j9vbCg06ke8mY1TryJAnr3VueD04bPxaUWVxuA6SEtF0yOwBTdnOH+4AMFhpOGyfEDNkqPxO6LSewnZrs+Nxn+2qXGC1oivUePJcJ6OhCWNFce6nK/vtAfLsampEHQUmPuhA6zwvHaZ5FyF2kRmflvAr17wvuABxCXJQ2wsjfr0Q8MHHpbYIVedeP36ZYzztd2ENOy/5EUZutigYMF38z8bnXuWZwkKYZ+Mk0bCVv1Wl2lh3VUJ6g83Z4Df1mel1sMjy9z9FW3+Fy4Z4bQf2KHgjl4unZsos7JJ3A9EU7K8d+C3Kv0KscXrMuSLuhMqnPB9DuO1W37FOgcHuBtdjnTtwu50FvxCoY3rdKvVjKiaEdWpdqbHu9JUWAsm8793lamZ5OiJmwjuzjLOc5K73xcj/9IyLDSpdUbG/KwpkLii2x4mxBa6NVRDMMzDGJhes8wWJlBTYgadtUnR0tqmrmtyXXJBbs3dkn3ibPC0GWp1xwOIFp7Yhsjmpx5YGBpXfpPE2X7l3RMeZgPB5dXrIj4gp9qvm2CNIaVDmMzcALKymxNzYQAw3eOszq4knHCvPap3TrGV+1IrxHKCuL/OKWCwI1VLzKsXwzWwGN0fGoHDe7JDGeLwzuvTUoyMKJ8MnX9qZd6t02dmfKguEeGOEMFsd/ekc9LqdaRMJ6aczG4ZFbGOEuu7J4mTtZKyRJO4an9c5uvkcxxllg/3uR54NRpBzzJfKivPZOc4Y4YZvh5Ha+FCzG0Usz0kfFq5plzOuIeE3PtILsn25Jp0MyG2nM8rwqv9cgxplnuqEIjjy0ExWd/0J1/C9ROWxegLc0CWph//KxvKSAdpvu0jrFkW5oJLqf9LG/eII3HO28r6EQ3401r0MhtMnTeDSE8Hl99Ry+7o5nv/GJdgax9GAZHqqlc30ZIZfyhVZWIxWVpbqBWv/DYUOmOQFQu3riMJcb77/sDHI9bLS0BjuwA23f8/bERRTLzKrgDIRzNOx786IzdnjAeb3barjLE895zT66J+gcqhuKo0rQ9/eUpNxIiSUtLQiFtKWC8HaZ+MKZecTZ7VOeZc5a1ExARbRn3i1KIm0bdLNKp603DVg7ved2IJ0Y8fdvWN8a+MDmHRYI52S2RcXTEUk1zOaIgzTsRFp5wl8aeTjizbWG3QNPwJhzpgpNlOvwPTTpaOl8TJkyYMGHChAkTJkyYMGHChAkTJkyYMGHi/x//BQxF0YH96qycAAAAAElFTkSuQmCC'
};
export const COMMON_APPSFLYER_QUERY_PARAMS = {
  af_xp: 'custom',
  c: 'Testing',
  cAET: 'Assignment deep link',
  af_dp: 'pearsonplus://',
  af_reengagement_window: 'lifetime',
  is_retargeting: true
};
export const APPSFLYERS_AUTHHOME = {
  pid: 'authhome_deeplinking_test',
  deep_link_value: 'auth_home',
  ...COMMON_APPSFLYER_QUERY_PARAMS
};
export const APPSFLYERS_EREADER = {
  pid: 'eReader_deeplinking_test',
  pidAET: 'eReader_deeplinking_assignment',
  deep_link_value: 'ereader',
  deep_link_sub1: 'assignment',
  ...COMMON_APPSFLYER_QUERY_PARAMS
};
export const PISESSION_ID = 'PISESSION_ID';
export const TOC_POSITION = {
  BELOW_HERO_BOOK: 'BELOW_HERO_BOOK',
  BELOW_CHANNEL_BANNER: 'BELOW_CHANNEL_BANNER'
};
export const HERO_BANNER_V1_VARIANTS = {
  DEFAULT: 'default',
  V2: 'v2'
};
export const LAST_INTERACTION_HERO = {
  TOC: 'TOC',
  GO_TO_PAGE: 'GO_TO_PAGE'
};
export const SOURCE_FROM = 'source_from';
export const HOME2 = 'home2';
export const GO_TO_PAGENO_QUERY_PARAM = 'printPage';
export const ASSIGNMENT_ID_QUERY_PARAM = 'assignmentId';
export const QUESTION_ID_QUERY_PARAM = 'questionId';
export const ONBOARDING_CTA_BUTTONS = {
  ON_BOARD_STUDY_CHANNEL_CTA: 'onBoardstudyChannelCTA'
};
export const ONBOARDING_SLIDES = {
  STUDY_EXAM_PREP: 'study_exam_prep',
  ADD_COURSE: 'about_channel_course',
  CUSTOM_STUDY_PLAN: 'create_another_course',
  EXAM_PREP: 'exam_prep'
};
export const DEFAULT_BOOK_COVER_IMAGE_PATH = '/assets/images/coverThumbnail.jpg';
export const ONE_READER_MODAL_ONBOARD_POPUP = 'ONE_READER_MODAL_ONBOARD_POPUP';
export const LOCAL_STORAGE_KEYS = {
  REFRESH_TOKEN: '.PiRefreshToken'
};
export const GO_TO_PAGE_MAX_LENGTH = 8;
export const ONBORAD_ACTION = {
  GOTO: 'GOTO',
  CLOSE: 'CLOSE',
  NEXT: 'NEXT'
};
export const APPSFLYERS_QRCODE_AUTHHOME = {
  pid: 'authhome_qr_code',
  deep_link_value: 'auth_home',
  ...COMMON_APPSFLYER_QUERY_PARAMS
};
export const APPSFLYERS_QRCODE_EREADER = {
  pid: 'eReader_qr_code',
  deep_link_value: 'ereader',
  ...COMMON_APPSFLYER_QUERY_PARAMS
};
export const QR_CODE_SERVICE_FETCHED = 'QR_CODE_SERVICE_FETCHED';
export const QR_CODE_HTTP_REQUEST_METHODS = {
  POST: 'POST'
};
export const MORE_AT_PEARSON = 'MORE_AT_PEARSON';
export const MY_ETEXTBOOK = 'MY_ETEXTBOOK';
export const CREATE_COURSE = 'CREATE_COURSE';

export const SET_HERO_DASHBOARD = 'SET_HERO_DASHBOARD';
export const HERO_CONTENT_CARD_POSITIONS = {
  COL1: 'col1',
  COL2: 'col2',
  TOP: 'top',
  BOTTOM: 'bottom'
};
export const MONDLY_CARD_POSITIONS = {
  COL1: 'col1',
  COL2: 'col2'
};
export const HERO_STYLES = {
  [HERO_BANNER_TYPES.BOOK]: {
    0: {},
    1024: {
      '--col2Width': '320px'
    },
    1280: {
      '--col2Width': '394px'
    },
    1440: {
      '--col2Width': '416px'
    },
    1920: {
      '--col2Width': '534px'
    }
  },
  [HERO_BANNER_TYPES.BOOK_WITH_CHANNEL]: {
    0: {},
    1024: {
      '--col2Width': '320px'
    },
    1280: {
      '--col2Width': '396px'
    },
    1440: {
      '--col2Width': '416px'
    },
    1920: {
      '--col2Width': '534px'
    }
  },
  [HERO_BANNER_TYPES.CHANNEL]: {
    0: {},
    1024: {
      '--col2Width': '320px'
    },
    1280: {
      '--col2Width': '396px'
    },
    1440: {
      '--col2Width': '416px'
    },
    1920: {
      '--col2Width': '534px'
    }
  },
  [HERO_BANNER_TYPES.MARKETING_TEMPLATE]: {
    0: {},
    1024: {
      '--col2Width': '488px'
    },
    1280: {
      '--col2Width': '604px'
    },
    1440: {
      '--col2Width': '640px'
    },
    1920: {
      '--col2Width': '816px'
    }
  }
};

export const HERO_ICONS = {
  BOOKMARK_ICON: 'BookmarkIcon',
  FLASHCARD_ICON: 'FlashcardIcon',
  TITLE_INFO_ICON: 'TitleInfoIcon',
  NOTES_ICON: 'NotesIcon',
  TOC_ICON: 'TocIcon',
  SEARCH_ICON: 'SearchIcon',
  DELETE_ICON: 'DeleteIcon'
};
export const ASSET_TYPES = {
  POPULAR_ASSETS: 'popular_assets',
  RECOMMENDED_ASSETS: 'recommended_assets'
};
export const CHANNEL_LINKS = {
  LEARN: 'learn',
  EXAM_PREP: 'exam_prep',
  AI_TUTOR: 'ai_tutor'
};
export const PPLUS_SUBSCRIPTIONS = {
  ETEXTBOOK: 'eTextbook',
  MYLAB_OR_MASTERING: 'MyLab_or_MasteringMastering',
  STUDY_EXAM_PREP: 'Study_Exam_Prep',
  STUDY_EXAM_PREP_PACK: 'Study_Exam_Prep_Pack'
};
export const CHANNEL_TOC_REQUESTED = 'CHANNEL_TOC_REQUESTED';
export const CHANNEL_TOC_FETCHED = 'CHANNEL_TOC_FETCHED';
export const CHANNEL_TOC_FAILED = 'CHANNEL_TOC_FAILED';
export const CHANNEL_PRACTICE_TOC_REQUESTED = 'CHANNEL_PRACTICE_TOC_REQUESTED';
export const CHANNEL_PRACTICE_TOC_FETCHED = 'CHANNEL_PRACTICE_TOC_FETCHED';
export const CHANNEL_PRACTICE_TOC_FAILED = 'CHANNEL_PRACTICE_TOC_FAILED';
export const HEADER_EVENT = {
  MORE_AT_PEARSON_EVENT_LABEL: 'header_more_at_pearson',
  MY_ETEXTBOOK_EVENT_LABEL: 'header_my_etextbooks',
  CONTINUE_IN_APP_EVENT_LABEL: 'header_continue_in_app',
  HEADER_LEARN_LANGUAGE_HEI_USER_LABEL: 'header_learn_language_HEI_user',
  PROMO_LEARN_LANGUAGE_HEI_USER_LABEL: 'promo_learn_language_HEI_user',
  PROMO_HEI_MONDLY: 'promo_HEI_mondly',
  SEARCH_EVENT_LABEL: 'search',
  LOGO_EVENT_LABEL: 'logo',
  HEADER_CLICK_EVENT_ACTION: 'click on other cta',
  TOAST_CLOSE: 'toast_close',
  TOAST_PEARSONPLUS_CLICK: 'toast_personplus_click',
  ETEXTHERO_MY_ETEXTBOOKS: 'etexthero_my_etextbooks',
  PROMO_LEARN_LANGUAGE_NESTEST_USER_LABEL: 'promo_nestest',
  SCHOOL_INFO_NOT_AVAILABLE_EVENT_LABEL: 'school_info_not_available'
};
export const COURSE_TAB_EVENT_TYPES = {
  BOOK: 'etext_only',
  BOOK_WITH_CHANNEL: 'etext_mappedchannel',
  CHANNEL: 'channels_only',
  ETEXT_RELATED_CHANNEL: 'etext_relatedchannel',
  ETEXT_MAPPEDCHANNEL_LITE: 'etext_mappedchannel_lite'
};
export const COURSE_TAB_EVENT = {
  OTHER_COURSE_EVENT_LABEL: 'other_course',
  LOADED_COURSE_EVENT_LABEL: 'loaded_course',
  COURSE_TAB_CLICK_EVENT_ACTION: 'user selects a course tab',
  ...COURSE_TAB_EVENT_TYPES
};
export const HEI_LEARN_LANGUAGE = 'HEI_LEARN_LANGUAGE';
export const CHANNEL_CARD_EVENT = {
  CHANNEL_CARD_ELEMENT_EVENT_LABEL: 'OpenChannel',
  CHANNEL_CARD_ELEMENT_CLICK_EVENT_ACTION: 'Click Channel Card Element',
  CHANNEL_CARD_ELEMENT_VIEW_EVENT_ACTION: 'View Channels Card',
  RECOMMENDED_CONTAINER_FIELD: 'recommended_container',
  EXAMPREP_CONTAINER_FIELD: 'examprep_container',
  CHANNEL_CONTAINER_FIELD: 'channel_container',
  STUDY_EXAMPREP_CARD_FIELD: 'study_examprep_card',
  STATUS_CARD_FIELD: 'status_card',
  PRIMARY_CTA_FIELD: 'primary_cta',
  TOPICS_CARD_CONTAINER_FIELD: 'topics_card',
  CHANNEL_CTA_CONTAINER_FIELD: 'channels_cta',
  CHANNELS_CONTAINER_FIELD: 'channels_container'
};
export const COURSE_COLLECTION_LIMIT = 19;
export const COURSE_COLLECTION_LIMIT_KEY = 'COURSE_COLLECTION_LIMIT_KEY';
export const EXAM_PREP_FLOW = {
  EXAM_PREP_CONTAINER: 'exam_prep_container',
  ADD_COURSE_FLOW: 'add_course_flow'
};
export const ONBOARDING_LINKS = {
  PURCHASE_ETEXT_BOOK: 'PURCHASE_ETEXT_BOOK',
  PURCHASE_ETEXT_WITHOUT_BOOK: 'PURCHASE_ETEXT_WITHOUT_BOOK'
};
export const AUTHHOME_UNBOXING_FLOW = {
  MLM: 'MLM',
  DTC: 'DTC',
  OTHER: 'OTHER'
};
export const QR_CODE_EVENT = {
  QR_CODE_EVENT_LABEL: 'QR code',
  QR_CODE_API_FAILURE_EVENT_LABEL: 'API failure',
  CONTINUE_IN_APP_CLICK_EVENT_ACTION: 'Click Continue in the App CTA',
  HEADER_FIELD: 'auth_home_web_header',
  PROFILE_DROPDOWN_FIELD: 'eReader_profile_dropdown',
  EREADER_HEADER_FIELD: 'eReader_header',
  OTHERS_FIELD: 'others'
};
export const QR_CODE_STATUS = {
  DONE: 'done',
  KEEPALIVE: 'keepalive',
  EXPIRED: 'expired'
};
export const PENDO_IDENTIFICATION_CLASS = {
  ONBOARDING_X_CLOSE: 'onereaderModalXClose',
  ONBOARDING_MAYBE_LATER: 'onereaderModalCTAMayBe'
};
export const CHANNEL_MAPPING_TYPES = {
  EXACT: 'EXACT',
  EXACTLITE: 'EXACT-LITE',
  RELATED: 'RELATED',
  GENERIC: 'GENERIC'
};
export const ETEXT_CHANNEL_MAPPING_TYPE_LABEL = {
  ETEXT_CHANNELS_EXACT: 'etext_channels_exact',
  ETEXT_CHANNELS_EXACTLITE: 'etext_channels_exactlite',
  ETEXT_CHANNELS_RELATED: 'etext_channels_related',
  ETEXT_CHANNELS_NOTMAPPED: 'etext_channels_notmapped'
};
export const NOT_AVAILABLE = 'notAvailable';
export const HIDE_CHANNEL_IDS = 'HIDE_CHANNEL_IDS';
export const AI_STUDY_TOOL_EVENT = {
  VIEW_AI_STUDY_TOOL_EVENT_ACTION: 'View GPT chatbot in Auth home',
  AI_STUDY_TOOL_CONVERSATION_EVENT_ACTION: 'Start GPT chatbot conversation in Auth home',
  AI_STUDY_TOOL_LOCATION_IN_APP: 'textbox_in_AuthHome',
  GPT_EVENT_CATEGORY: 'GPT',
  GPT_EVENT: 'gptevent',
  GPT_CLICK_EVENT_ACTION: 'Click Chat GPT',
  GPT_CLICK_SEND_EVENT_ACTION: 'Click Send',
  TRIGGER: {
    SYSTEM: 'System',
    CLICKED: 'Clicked',
    ICON: 'Icon',
    RAISED_HAND: 'Raised Hand'
  },
  COMMAND_SOURCE_CODE: {
    TYPE: 'type',
    CLICK: 'click',
    VOICE: 'voice'
  },
  INITIATED_POINT: {
    COMMAND_LINE: 'Command Line'
  },
  EVENT_LABEL: {}
};
export const TOC_TYPE_MODULE = 'module';
export const TOC_TYPE_SUBMODULE = 'submodule';
export const TOC_TYPE_PAGE = 'page';
export const ETEXT_RELATED_CHANNEL = 'ETEXT_RELATED_CHANNEL';
export const ETEXT_MAPPEDCHANNEL_LITE = 'ETEXT_MAPPEDCHANNEL_LITE';
export const SESSION_EVENT = {
  INACTIVITY_EVENT_LABEL: 'inactivity',
  SYSTEM_DISPLAY_TIMEOUT_EVENT_ACTION: 'System Display Timeout Warning Modal',
  SYSTEM_FIELD: 'system'
};
export const STUDY_EXAM_COMPONENT_POSITION = 'STUDY_EXAM_COMPONENT_POSITION';
export const USER_ACCESS_TYPE_VALUES = {
  DISAGGREGATED: 'disaggregated',
  FULL: 'full'
};
export const PRINT_PAGE_ILLUSTRATION = '/assets/images/print_page_illustration.png';
export const LIGHTWEIGHT_CHANNEL_TYPE = 'lightweight';
export const AI_CHAT_VARIANT = {
  A: 'A',
  B: 'B',
  C: 'C'
};
export const VARIANT_V1 = 'v1';
export const CREATE_COURSE_EVENT = {
  ACTION_NAME: 'User creates a new course'
};
export const CHANNEL_FILTER = {
  ALL_CHANNELS: 'All Channels',
  RECOMMENDED: 'Recommended'
};
export const BOOK_PREFERENCES_FETCHED = 'BOOK_PREFERENCES_FETCHED';
export const BOOK_PREFERENCES_REQUESTED = 'BOOK_PREFERENCES_REQUESTED';
export const BOOK_PREFERENCES_ERROR = 'BOOK_PREFERENCES_ERROR';
export const COMPONENT_IDS = {
  EREADER_QR_CODE_CTA: 'EREADER_QR_CODE_CTA',
  BOTTOM_BANNER: 'NATIVE_APP_BOTTOM_BANNER',
  BOTTOM_SHEET: 'NATIVE_APP_BOTTOM_SHEET',
  MODAL: 'NATIVE_APP_MODAL',
  FEEDBACK: 'PPLUS_FEEDBACK_PENDO_PLACEHOLDER',
  ...QR_COMPONENT_IDS
};
export const CHANNEL_HYPER_LINKS = {
  LEARN: 'learn',
  AI_TUTOR: 'ai-tutor',
  EXAM_PREP: 'exam-prep'
};
export const ASSET_TABS_VALUE = {
  LEARN: 'Learn',
  PRACTICE: 'Practice'
};
export const PRACTICE_ASSET_VARIANT = {
  ON_TOC_FOOTER: 'A',
  ON_TOC_FLOW_TAB: 'B'
};
export const CHANNEL_SUBSCRIPTION_TYPES = {
  BUNDLE: 'bundle',
  STANDALONE: 'standalone_subscription'
};
export const AI_CHAT_BOT_CLIENT_APP = 'ISE';
export const NOTE_BOOK_VERSION = 'NOTE_BOOK_VERSION';
export const VIEW_CHANNELS_CARD_SCROLL_EVENT = {
  LEARN_ASSETS_CONTAINER: 'learn_videos',
  PRACTICE_ASSETS_CONTAINER: 'practice',
  SUBSCRIPTION_STATUS: 'status_card',
  HIGHLIGHT_PROMO_COL2: 'ai_tutor_card',
  UPLOAD_SYLLABUS_CARD: 'examprep_container',
  POPULAR_CHANNELS_SLIDER: 'other_channels_container',
  POPULAR_CHANNELS_EMPTY_STATE: 'channels_container',
  RELATED_CHANNEL: 'related_channel',
  HIGHLIGHT_PROMO_TOP: 'ai_tutor_card',
  REVIEW_REMEDIATION_CONTAINER: 'review_tab',
  REMEDIATION_CONTAINER: 'up_next tab'
};

export const POPULAR_CHANNELS_WITH_CHANNEL_ID = 'popular_channels_with_channel_id';
export const POPULAR_CHANNELS_WITH_OUT_CHANNEL_ID = 'popular_channels_with_out_channel_id';

export const DIAGNOSTICS_SERVICE_REQUESTED = 'diagnostics_service_requested';

export const PDP_SERVICE_REQUESTED = 'pdp_service_requested';
export const PDP_SERVICE_FETCHED = 'pdp_service_fetched';
export const PDP_SERVICE_ERROR = 'pdp_service_error';

export const CONTEXT_ID = 'contextId';

export const LMS_LAUNCH_CONTEXT = 'lms_launch_context';

export const LMS_LICENSE_TYPE = {
  RETAIL: 'RETAIL',
  INCLUSIVE: 'INCLUSIVE'
};

export const LMS_LAUNCH_TYPE_RETAIL = 'Pearson Integration LTI 1.3';
export const LMS_LAUNCH_TYPE_INCLUSIVE = 'Channel Partner Integration';
export const LMS_ENROLLED = 'Enrolled';

export const DIAGNOSTIC_HEADINGS = {
  DIAGNOSTICS_INFORMATION: 'Diagnostics Information',
  LAUNCH_TYPE: 'Launch Type',
  DIAGNOSTICS_TIMESTAMP: 'Diagnostics Timestamp',
  URL: 'URL',
  YOUR_ACCOUNTS: 'Your Accounts',
  USER_ID: 'User ID',
  USER_NAME: 'User Name',
  USER_KEY: 'User Key',
  PEARSON_USER_ID: 'Pearson User ID',
  YOUR_ENROLLMENT: 'Your Enrollment',
  COURSE_ROLE: 'Course Role',
  COURSE_INFORMATION: 'Course Information',
  PEARSON_COURSE_KEY: 'Pearson Course Key',
  COURSE_ID: 'Course ID',
  PRODUCT_MODEL_TYPE: 'Product Model Type',
  USER_INFORMATION: 'User Information',
  ENROLLMENT_STATUS: 'Enrollment Status',
  CLIENT_INFORMATION: 'Client Information',
  CLIENT_OS: 'Client OS',
  INTERNET_BROWSER: 'Internet Browser',
  DEVICE: 'Device',
  ORGANIZATIONAL_DATA: 'Organizational Data',
  ORGANIZATION_ID: 'Organization ID',
  ORGANIZATION_NAME: 'Organization Name',
  INTEGRATION_INFORMATION: 'Integration Information',
  CONSUMER_CODE: 'Consumer Code',
  VERSION: 'Version',
  INSTITUTION_CODE: 'Institution Code',
  LAUNCH_CONTEXT_KEY_INFORMATION: 'Launch Context Key Information',
  LAUNCH_CONTEXT_TOKEN: 'Launch Context Token'
};
export const LEFT_NAV_MENU_LABEL = {
  HOME: 'Home',
  ETEXTBOOK: 'eTextbook',
  STUDY_PREP: 'Study Prep'
};
export const LEFT_NAV_MENU_KEY = {
  HOME: 'home',
  ETEXT: 'eText',
  STUDYPREP: 'StudyPrep'
};
export const LEFT_NAV_MENU_EVENT_LABEL = {
  HOME: 'Home',
  ETEXT: 'eText',
  STUDYPREP: 'Study Prep',
  NAV_OPEN: 'nav_open',
  NAV_CLOSE: 'nav_close'
};
export const GLOBAL_NAV_EVENT = {
  ...LEFT_NAV_MENU_EVENT_LABEL,
  LEFT_NAV_ELEMENT_CLICK_EVENT_ACTION: 'Click Left Navigation Object'
};
export const PRODUCT_ROUTES = route => [
  `${route}/products/:id`,
  `${route}/products/:id/contents`,
  `${route}/products/:id/pages/:pageId`,
  `${route}/products/:id/bundles/:bundleId`,
  `${route}/products/:id/bundles/:bundleId/pages/:pageId?`
];
export const COURSE_ROUTES = route => [
  `${route}/courses/:id`,
  `${route}/courses/:id/contents`,
  `${route}/courses/:id/pages/:pageId?`,
  `${route}/courses/:id/products/:productId`,
  `${route}/courses/:id/products/:productId/pages/:pageId?`,
  `${route}/courses/:id/products/:productId/bundles/:bundleId`,
  `${route}/courses/:id/products/:productId/bundles/:bundleId/pages/:pageId?`
];
export const HOME_ROUTES = [
  '/home',
  '/home/:expandContainer'
];
export const HOME2_ROUTES = [
  '/home2',
  '/home2/:mlmcontextencoded'
];
export const STUDY_PREP_ROUTES = route => [
  `${route}/channels/study-prep`
];
export const HOME_ROUTE = '/home';
export const HOME2_ROUTE = '/home2';
export const EVENT_BUS = {
  PRODUCT_CONTAINER: 'PRODUCT_CONTAINER',
  COURSE_CONTAINER: 'COURSE_CONTAINER',
  INSTRUCTOR_DASHBOARD_CONTAINER: 'INSTRUCTOR_DASHBOARD_CONTAINER',
  GLOBAL: 'GLOBAL'
};
export const TOGGLE_LEFT_NAV = 'TOGGLE_LEFT_NAV';
export const PPLUS_GLOBAL_NAV_PREFIX = 'PPLUS_GLOBAL_NAV_';
export const VEGA_READER = 'VEGA_READER';
export const IFRAME_QUERY_STRING = 'iframe=authhome';
export const STUDY_PREP_QUERY_PARAM = 'CEP=plusAuthHP_GlobalNav';
export const APPSTORE_RATING = 'APPSTORE_RATING';
export const PLAYSTORE_RATING = 'PLAYSTORE_RATING';
export const PROMO_BANNER_VARIANT = {
  V2: 'v2'
};
export const QR_CODE_TEST_VARIANT_EVENT_LABEL = {
  [QR_CODE_VARIANT.V1]: 'QR_ContentCard_left_w/image',
  [QR_CODE_VARIANT.V2]: 'QR_ContentCard_left_wo/image',
  [QR_CODE_VARIANT.V3]: 'QR_footer',
  [QR_CODE_VARIANT.V4]: 'QR_ContentCard_right',
  [QR_CODE_VARIANT.V5]: 'QR_Modal_Overlay',
  [QR_CODE_VARIANT.V6]: 'QR_Right_Icon'
};
export const NATIVE_APP_PROMO_TEST_EVENT_LABEL = {
  [NATIVE_APP_PROMO_TYPES.BANNER]: 'bottom_banner',
  [NATIVE_APP_PROMO_TYPES.DRAWER]: 'bottom_sheet',
  [NATIVE_APP_PROMO_TYPES.MODAL]: 'modal'
};
export const QR_CODE_VIEW_EVENT = {
  EVENT_ACTION: 'View QR',
  EVENT_LABEL_CARD: 'QR Card',
  EVENT_LABEL_CONTINUE_IN_THE_APP: 'Continue_in_App'
};
export const GET_HELP_BUTTON_ID = 'embeddedMessagingConversationButton';
export const HEI_BMC_CODES_LIST = [
  DIRECT_TO_CONSUMER_HEI,
  DIRECT_TO_CONSUMER_HEIUK,
  DIRECT_TO_CONSUMER_HEICA,
  DIRECT_TO_CONSUMER_HEILATAM
];
export const K12_BMC_LIST = [
  INSTRUCTOR_LED_SAET_K12,
  INSTRUCTOR_LED_SAET_IA_K12
];
export const DELAY_FOR_LEFT_NAV = 1500;
export const POST_MESSAGE_TYPE = {
  CHANNEL: 'CHANNEL',
  CHATBOT: 'EMBEDDED_MESSAGING_DISPATCH_EVENT_TO_HOST'
};
export const CHANNEL_POST_MESSAGE_ACTION = {
  LOGOACTION: 'LOGOACTION',
  LOGOUT: 'LOGOUT'
};
export const CHANNEL_OPTION_CB_VALUES = {
  SAMPLE: 'sample',
  USER: 'user'
};

export const LMS_PDP_REDIRECT_EVENT = 'LMS_PDP_REDIRECT_EVENT';

export const AET_ROUTES = {
  HOME: '/aet/home',
  SYLLABUS: '/aet/assignments',
  ASSIGNMENTS: '/aet/home/assignments',
  ASSIGNMENT_DETAILS: '/aet/home/assignments/:assignmentId',
  STUDENT_DETAILS: '/aet/home/assignments/:assignmentId/students/:studentId',
  SUCCESS: '/aet/assignmentsetup/success',
  INSTRUCTOR_DASHBOARD: '/aet/dashboard',
  UPNEXT: '/aet/upnext',
  STUDENT_ROSTER: '/aet/home/student-roster',
  STUDENT_ROSTER_DETAILS: '/aet/home/student-roster/:studentId',
  // eslint-disable-next-line max-len
  INSTRUCTOR_DASHBOARD_DIFFICULT_TOPICS: '/aet/dashboard/assignments/:assignmentId/difficult-topics/:topicId',
  // eslint-disable-next-line max-len
  INSTRUCTOR_DASHBOARD_STUDENT_PERFORMANCE: '/aet/dashboard/assignments/:assignmentId/student-performance/:studentId',
  STUDENT_DASHBOARD: '/aet/student/dashboard',
  Iframe_DASHBOARD: '/aet/embedIframe',
  STUDENT_REVIEW: '/aet/home/review',
  DIFFICULT_TOPIC_DETAILS: '/aet/home/assignments/:assignmentId/difficult-topic/:difficultTopicId'
};

/**
 * Multi-context route arrays for AET routes
 * These allow the same component to be rendered for /home, /home2, and /aet/home contexts
 */
export const AET_ROUTES_ALL_CONTEXTS = {
  HOME: [
    AET_ROUTES.HOME, // /aet/home
    HOME_ROUTE, // /home
    HOME2_ROUTE, // /home2
    '/home2/:mlmcontextencoded' // /home2/:mlmcontextencoded
  ],
  ASSIGNMENTS: [
    AET_ROUTES.ASSIGNMENTS, // /aet/home/assignments
    '/home/assignments', // /home/assignments
    '/home2/:mlmcontextencoded/assignments', // /home2/:mlmcontextencoded/assignments (must come before /home2/assignments)
    '/home2/assignments' // /home2/assignments
  ],
  ASSIGNMENT_DETAILS: [
    AET_ROUTES.ASSIGNMENT_DETAILS, // /aet/home/assignments/:assignmentId
    '/home/assignments/:assignmentId', // /home/assignments/:assignmentId
    '/home2/:mlmcontextencoded/assignments/:assignmentId', // /home2/:mlmcontextencoded/assignments/:assignmentId
    '/home2/assignments/:assignmentId' // /home2/assignments/:assignmentId
  ],
  STUDENT_ROSTER: [
    AET_ROUTES.STUDENT_ROSTER, // /aet/home/student-roster
    '/home/student-roster', // /home/student-roster
    '/home2/:mlmcontextencoded/student-roster', // /home2/:mlmcontextencoded/student-roster
    '/home2/student-roster' // /home2/student-roster
  ],
  STUDENT_ROSTER_DETAILS: [
    AET_ROUTES.STUDENT_ROSTER_DETAILS, // /aet/home/student-roster/:studentId
    '/home/student-roster/:studentId', // /home/student-roster/:studentId
    '/home2/:mlmcontextencoded/student-roster/:studentId', // /home2/:mlmcontextencoded/student-roster/:studentId
    '/home2/student-roster/:studentId' // /home2/student-roster/:studentId
  ],
  STUDENT_REVIEW: [
    AET_ROUTES.STUDENT_REVIEW, // /aet/home/review
    '/home/review', // /home/review
    '/home2/:mlmcontextencoded/review', // /home2/:mlmcontextencoded/review
    '/home2/review' // /home2/review
  ],
  STUDENT_DETAILS: [
    AET_ROUTES.STUDENT_DETAILS, // /aet/home/assignments/:assignmentId/students/:studentId
    '/home/assignments/:assignmentId/students/:studentId', // /home/assignments/:assignmentId/students/:studentId
    '/home2/:mlmcontextencoded/assignments/:assignmentId/students/:studentId', // /home2/:mlmcontextencoded/assignments/:assignmentId/students/:studentId
    '/home2/assignments/:assignmentId/students/:studentId' // /home2/assignments/:assignmentId/students/:studentId
  ],
  DIFFICULT_TOPIC_DETAILS: [
    AET_ROUTES.DIFFICULT_TOPIC_DETAILS,
    '/home/assignments/:assignmentId/difficult-topic/:difficultTopicId',
    '/home2/:mlmcontextencoded/assignments/:assignmentId/difficult-topic/:difficultTopicId',
    '/home2/assignments/:assignmentId/difficult-topic/:difficultTopicId'
  ]
};

export const AGENTIC_GRAPH_CONFIG = {
  graphId: '',
  graphVersion: ''
};

export const INIT_NO_EXAMS = 'INIT_NO_EXAMS';
export const INIT_WITH_EXAMS = 'INIT_WITH_EXAMS';
export const EXAM_REVIEW_COMPLETE = 'EXAM_REVIEW_COMPLETE';

export const INSTRUCTOR_DASHBOARD_TABS = {
  UP_NEXT: 'UP_NEXT_INSIGHTS_TAB',
  ASSIGNMENTS: 'ASSIGNMENTS_INSIGHTS_TAB',
  STUDENT_ROSTER: 'STUDENT_ROSTER_INSIGHTS_TAB'
};

export const PERFORMANCE_STATUS_KEYS = [
  'totalQuestions',
  'great',
  'gettingThere',
  'needReview',
  'notAttmpted'
];

export const PERFORMANCE_STATUS = {
  QUESTIONS_TOTAL: 'questionstotal',
  GREAT: 'great',
  GETTING_THERE: 'gettingthere',
  NEEDS_REVIEW: 'needsreview',
  COMPLETED_PAST_DUE: 'completedPastDue',
  NA: 'N/A'
};

export const ON_HERO_BANNER_SET = 'ON_HERO_BANNER_SET';
export const YES = 'yes';

export const STUDENT_DASHBOARD_TABS = {
  UP_NEXT: 'UP_NEXT',
  ASSIGNMENTS: 'ASSIGNMENTS',
  REVIEW: 'REVIEW'
};

export const THEMES = {
  LIGHT: 'light',
  DARK: 'dark'
};
export const NO = 'no';

export const ASSIGNMENT_FORM_ACTIONS = {
  SAVE: 'save',
  SAVE_AND_ADD: 'saveAndAdd',
  DELETE: 'delete',
  SAVE_AND_CLOSE: 'saveAndClose'
};

export const ASSIGNMENT_FORM_ACTIONS_EVENT_LABEL = {
  SAVE: 'save',
  SAVEANDADD: 'save_create',
  SAVEANDCLOSE: 'save_close'
};

export const STATUS_COLOR_MAP = {
  COMPLETED: 'completed',
  COMPLETED_PAST_DUE: 'completedPastDue',
  IN_PROGRESS: 'inprogress',
  NOT_STARTED: 'notstarted'
};

export const ASSIGNMENT_TYPES = {
  QUIZ: 'QUIZ',
  HOMEWORK: 'HOMEWORK',
  LECTURE: 'LECTURE'
};


/** Default syllabus schedule excluded types if AWS data is not available */
export const DEFAULT_SYLLABUS_SCHEDULE_EXCLUDED_TYPES = [
  'exam',
  'quiz',
  'lab',
  'tutorial',
  'project',
  'other',
  'recitation'
];

/** Container data key for syllabus schedule excluded types */
export const SYLLABUS_SCHEDULE_EXCLUDED_TYPES = 'SYLLABUS_SCHEDULE_EXCLUDED_TYPES';

export const PROGRESS_STATUS_IDS = {
  NOT_STARTED: 'NOT_STARTED',
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETED: 'COMPLETED',
  COMPLETED_LATE: 'COMPLETED_LATE'
};

export const AET_THEME = 'plusAssignable';
export const IFRAME = 'iframe';

export const HOME_AET_ROUTES = [
  '/home/assignments',
  '/home/assignments/:assignmentId',
  '/home/student-roster',
  '/home/student-roster/:studentId',
  '/home/review',
  '/home/assignments/:assignmentId/students/:studentId',
  '/home/assignments/:assignmentId/difficult-topic/:difficultTopicId'
];

export const HOME2_AET_ROUTES = [
  '/home2/assignments',
  '/home2/:mlmcontextencoded/assignments',
  '/home2/assignments/:assignmentId',
  '/home2/:mlmcontextencoded/assignments/:assignmentId',
  '/home2/student-roster',
  '/home2/:mlmcontextencoded/student-roster',
  '/home2/student-roster/:studentId',
  '/home2/:mlmcontextencoded/student-roster/:studentId',
  '/home2/review',
  '/home2/:mlmcontextencoded/review',
  '/home2/assignments/:assignmentId/students/:studentId',
  '/home2/:mlmcontextencoded/assignments/:assignmentId/students/:studentId',
  '/home2/assignments/:assignmentId/difficult-topic/:difficultTopicId',
  '/home2/:mlmcontextencoded/assignments/:assignmentId/difficult-topic/:difficultTopicId'
];

export const ASSIGNMENT_SETTINGS_CONFIGURATION_KEYS = {
  SCORE_TYPE: 'assignment.scoreType',
  SCORE_BASE_VALUE: 'assignment.score.baseValue',
  AVAILABLE_BEFORE_DUE_DAYS: 'assignment.availableBeforeDueDays',
  DEFAULT_DUE_TIME: 'assignment.defaultDateTime',
  COURSE_TIME_ZONE: 'assignment.defaultTimeZone'
};

export const INSTRUCTOR_COURSE_TABS = {
  CURRENT: 'CURRENT',
  PAST: 'PAST',
  SETTINGS: 'SETTINGS',
  ASSIGNMENT_SETTINGS: 'ASSIGNMENT_SETTINGS',
  MANAGE_ROSTER: 'MANAGE_ROSTER'
};

// matches the exact string values CourseManagementView.getActiveTabForSkeleton() returns
export const SKELETON_ACTIVE_TAB = {
  SETTINGS: 'settings',
  ASSIGNMENT_SETTINGS: 'assignment-settings',
  ROSTER: 'roster'
};

export const INSTRUCTOR_COURSE_ROUTES = {
  ALL: '/course',
  PAST: '/course/past',
  NEW: '/course/new',
  CREATE: '/course/create',
  COPY: '/course/:courseId/copy',
  SETTINGS: '/course/:courseId/settings',
  ASSIGNMENT_SETTINGS: '/course/:courseId/assignment-settings',
  ROSTER: '/course/:courseId/roster'
};

export const INSTRUCTOR_COURSE_ROUTES_ALL_CONTEXTS = {
  ALL: [
    `${HOME_ROUTE}${INSTRUCTOR_COURSE_ROUTES.ALL}`,
    `${HOME2_ROUTE}${INSTRUCTOR_COURSE_ROUTES.ALL}`,
    `${HOME2_ROUTE}/:mlmcontextencoded${INSTRUCTOR_COURSE_ROUTES.ALL}`
  ],
  PAST: [
    `${HOME_ROUTE}${INSTRUCTOR_COURSE_ROUTES.PAST}`,
    `${HOME2_ROUTE}${INSTRUCTOR_COURSE_ROUTES.PAST}`,
    `${HOME2_ROUTE}/:mlmcontextencoded${INSTRUCTOR_COURSE_ROUTES.PAST}`
  ],
  NEW: [
    `${HOME_ROUTE}${INSTRUCTOR_COURSE_ROUTES.NEW}`,
    `${HOME2_ROUTE}${INSTRUCTOR_COURSE_ROUTES.NEW}`,
    `${HOME2_ROUTE}/:mlmcontextencoded${INSTRUCTOR_COURSE_ROUTES.NEW}`
  ],
  CREATE: [
    `${HOME_ROUTE}${INSTRUCTOR_COURSE_ROUTES.CREATE}`,
    `${HOME2_ROUTE}${INSTRUCTOR_COURSE_ROUTES.CREATE}`,
    `${HOME2_ROUTE}/:mlmcontextencoded${INSTRUCTOR_COURSE_ROUTES.CREATE}`
  ],
  COPY: [
    `${HOME_ROUTE}${INSTRUCTOR_COURSE_ROUTES.COPY}`,
    `${HOME2_ROUTE}${INSTRUCTOR_COURSE_ROUTES.COPY}`,
    `${HOME2_ROUTE}/:mlmcontextencoded${INSTRUCTOR_COURSE_ROUTES.COPY}`
  ],
  SETTINGS: [
    `${HOME_ROUTE}${INSTRUCTOR_COURSE_ROUTES.SETTINGS}`,
    `${HOME2_ROUTE}${INSTRUCTOR_COURSE_ROUTES.SETTINGS}`,
    `${HOME2_ROUTE}/:mlmcontextencoded${INSTRUCTOR_COURSE_ROUTES.SETTINGS}`
  ],
  ASSIGNMENT_SETTINGS: [
    `${HOME_ROUTE}${INSTRUCTOR_COURSE_ROUTES.ASSIGNMENT_SETTINGS}`,
    `${HOME2_ROUTE}${INSTRUCTOR_COURSE_ROUTES.ASSIGNMENT_SETTINGS}`,
    `${HOME2_ROUTE}/:mlmcontextencoded${INSTRUCTOR_COURSE_ROUTES.ASSIGNMENT_SETTINGS}`
  ],
  ROSTER: [
    `${HOME_ROUTE}${INSTRUCTOR_COURSE_ROUTES.ROSTER}`,
    `${HOME2_ROUTE}${INSTRUCTOR_COURSE_ROUTES.ROSTER}`,
    `${HOME2_ROUTE}/:mlmcontextencoded${INSTRUCTOR_COURSE_ROUTES.ROSTER}`
  ]
};

export const HOME_INSTRUCTOR_COURSE_ROUTES = [
  `${HOME_ROUTE}${INSTRUCTOR_COURSE_ROUTES.ALL}`,
  `${HOME_ROUTE}${INSTRUCTOR_COURSE_ROUTES.PAST}`,
  `${HOME_ROUTE}${INSTRUCTOR_COURSE_ROUTES.NEW}`,
  `${HOME_ROUTE}${INSTRUCTOR_COURSE_ROUTES.CREATE}`,
  `${HOME_ROUTE}${INSTRUCTOR_COURSE_ROUTES.COPY}`,
  `${HOME_ROUTE}${INSTRUCTOR_COURSE_ROUTES.SETTINGS}`,
  `${HOME_ROUTE}${INSTRUCTOR_COURSE_ROUTES.ASSIGNMENT_SETTINGS}`,
  `${HOME_ROUTE}${INSTRUCTOR_COURSE_ROUTES.ROSTER}`
];

export const HOME2_INSTRUCTOR_COURSE_ROUTES = [
  `${HOME2_ROUTE}${INSTRUCTOR_COURSE_ROUTES.ALL}`,
  `${HOME2_ROUTE}/:mlmcontextencoded${INSTRUCTOR_COURSE_ROUTES.ALL}`,
  `${HOME2_ROUTE}${INSTRUCTOR_COURSE_ROUTES.PAST}`,
  `${HOME2_ROUTE}/:mlmcontextencoded${INSTRUCTOR_COURSE_ROUTES.PAST}`,
  `${HOME2_ROUTE}${INSTRUCTOR_COURSE_ROUTES.NEW}`,
  `${HOME2_ROUTE}/:mlmcontextencoded${INSTRUCTOR_COURSE_ROUTES.NEW}`,
  `${HOME2_ROUTE}${INSTRUCTOR_COURSE_ROUTES.CREATE}`,
  `${HOME2_ROUTE}/:mlmcontextencoded${INSTRUCTOR_COURSE_ROUTES.CREATE}`,
  `${HOME2_ROUTE}${INSTRUCTOR_COURSE_ROUTES.COPY}`,
  `${HOME2_ROUTE}/:mlmcontextencoded${INSTRUCTOR_COURSE_ROUTES.COPY}`,
  `${HOME2_ROUTE}${INSTRUCTOR_COURSE_ROUTES.SETTINGS}`,
  `${HOME2_ROUTE}/:mlmcontextencoded${INSTRUCTOR_COURSE_ROUTES.SETTINGS}`,
  `${HOME2_ROUTE}${INSTRUCTOR_COURSE_ROUTES.ASSIGNMENT_SETTINGS}`,
  `${HOME2_ROUTE}/:mlmcontextencoded${INSTRUCTOR_COURSE_ROUTES.ASSIGNMENT_SETTINGS}`,
  `${HOME2_ROUTE}${INSTRUCTOR_COURSE_ROUTES.ROSTER}`,
  `${HOME2_ROUTE}/:mlmcontextencoded${INSTRUCTOR_COURSE_ROUTES.ROSTER}`
];

export const BADGE_TOOLTIP_STATUS = {
  COMPLETED_ON_TIME: 'completedOnTime',
  COMPLETED_PAST_DUE: 'completedPastDue'
};

export const ANSWERCONFIDENCE_KEY = ['needReview', 'gettingThere', 'great'];

export const GET_HELP_CHATBOT_ID = 'get-help-chatbot-container';
export const INFO = 'info';
export const SUCCESS = 'success';
export const ERROR = 'error';

export const THREE_DOT_MENU_CONSTANTS = {
  COURSE_SETTINGS: 'course-settings',
  ASSIGNMENT_SETTINGS: 'assignment-settings',
  PEARSON_EBOOK_RESOURCES: 'pearson-ebook-resources',
  ETEXTBOOK_INFORMATION: 'eTextbook-information',
  MANAGE_ROSTER: 'manage-roster',
  MANAGE_GRADE_SYNC: 'manage-grade-sync',
  COPY_COURSE: 'copy-course',
  UNLINK_COURSE: 'unlink-course'
};

export const COURSE_MENU_ORDER = [
  THREE_DOT_MENU_CONSTANTS.COURSE_SETTINGS,
  THREE_DOT_MENU_CONSTANTS.ASSIGNMENT_SETTINGS,
  THREE_DOT_MENU_CONSTANTS.MANAGE_ROSTER,
  THREE_DOT_MENU_CONSTANTS.MANAGE_GRADE_SYNC,
  THREE_DOT_MENU_CONSTANTS.ETEXTBOOK_INFORMATION,
  THREE_DOT_MENU_CONSTANTS.PEARSON_EBOOK_RESOURCES,
  THREE_DOT_MENU_CONSTANTS.COPY_COURSE,
  THREE_DOT_MENU_CONSTANTS.UNLINK_COURSE
];

export const COURSE_MENU_ORDER_L2 = [
  THREE_DOT_MENU_CONSTANTS.COURSE_SETTINGS,
  THREE_DOT_MENU_CONSTANTS.ASSIGNMENT_SETTINGS,
  THREE_DOT_MENU_CONSTANTS.MANAGE_ROSTER,
  THREE_DOT_MENU_CONSTANTS.ETEXTBOOK_INFORMATION,
  THREE_DOT_MENU_CONSTANTS.PEARSON_EBOOK_RESOURCES,
  THREE_DOT_MENU_CONSTANTS.COPY_COURSE
];

export const PROGRESS_TYPE = ['Not attempted', 'Completed', 'In progress'];

export const COMPONENT_CLASSES = {
  COURSE_MENU_ICON: 'aet-course-menu-icon',
  ACTIVE_COURSE_MENU_ICON: 'aet-active-course-menu-icon',
  ETEXT_CARD: 'aet-eText-card',
  ETEXT_COVER_IMAGE_CONTAINER: 'aet-eText-cover-image-container',
  COURSE_MENU_ITEM: 'aet-course-menu-item',
  TABS: 'aet-tabs',
  WELCOME_CARD: 'aet-welcome-card',
  SETUP_FLOW_PAGE: 'aet-setup-flow-page'
};

export const COURSE_CONFIGURATION_REQUESTED = 'COURSE_CONFIGURATION_REQUESTED';
export const COURSE_CONFIGURATION_FETCHED = 'COURSE_CONFIGURATION_FETCHED';
export const COURSE_CONFIGURATION_FAILED = 'COURSE_SETTINGS_FAILED';
export const INSTRUCTOR_COURSE_CONFIGURATIONS_REQUESTED = 'INSTRUCTOR_COURSE_CONFIGURATIONS_REQUESTED';
export const INSTRUCTOR_INSTITUTIONS_REQUESTED = 'INSTRUCTOR_INSTITUTIONS_REQUESTED';
export const INSTRUCTOR_INSTITUTIONS_FETCHED = 'INSTRUCTOR_INSTITUTIONS_FETCHED';
export const INSTRUCTOR_INSTITUTIONS_FAILED = 'INSTRUCTOR_INSTITUTIONS_FAILED';

export const ETEXT_PREFERENCE_SOURCE = {
  AITutor: COURSE_CONFIGURATION_KEYS.IS_AI_STUDY_ENABLED,
  studyPanelChannelsWidget: COURSE_CONFIGURATION_KEYS.IS_STUDY_PREP_ENABLED,
  unassignedMCQ: COURSE_CONFIGURATION_KEYS.IS_UNASSIGNED_MCQ_ENABLED
};

export const DYNAMIC_PDP_PAGE_URL = 'DYNAMIC_PDP_PAGE_URL';

// Tab IDs for syllabus upload
export const TAB_IDS = {
  UPLOAD: 'upload',
  ADD_MANUALLY: 'addmanually',
  DATE_ADJUSTER: 'dateadjuster'
};

// Default tab order configuration
export const DEFAULT_TAB_ORDER = [
  { index: 0, id: TAB_IDS.ADD_MANUALLY },
  { index: 1, id: TAB_IDS.UPLOAD }
];

export const VIDEO_ASSET_TYPES = [
  ASSET_CONTENT_TYPE.VIDEO_STREAM
];

export const PRACTICE_ASSET_TYPES = [
  ASSET_CONTENT_TYPE.MULTIPLE_CHOICE
];

export const SCHOOL_INFO_CARD_VARIANT = {
  FALSE: false,
  DEFAULT: 'default',
  V1: 'v1'
};

export const SCHOOL_INFO_CARD_ICONS = {
  CAUTION: 'CautionIcon',
  ADD: 'AddIconV1',
  TICK: 'TickIconV1'
};

export const SCHOOL_INFO_STEPS = {
  PICK_INSTITUTION: 'pickInstitution',
  ADD_SYLLABUS: 'addSyllabus'
};

export const SCHOOL_INFO_EVENTS = {
  EVENT_ACTION: {
    CLICK_TO_UPDATE_INSTITUTION: 'Click to Update Institution',
    CLICK_TO_ADD_INSTITUTION: 'Click to Add Institution',
    VIEW_INSTITUTION_SELECTION_MODAL: 'View Institution Selection Modal',
    SELECT_INSTITUTION: 'Select Institution'
  },
  EVENT_LABEL: {
    ADD: 'add',
    UPDATE: 'update',
    EMPTY_STATE: 'empty_state',
    PRE_SET: 'pre_set',
    LISTED_INSTITUTION: 'listed_institution',
    NOT_AVAILABLE: 'not_available'
  }
};

export const USER_ORG_MAPPING_REQUESTED = 'USER_ORG_MAPPING_REQUESTED';
export const USER_ORG_MAPPING_FETCHED = 'USER_ORG_MAPPING_FETCHED';
export const USER_ORG_MAPPING_FAILED = 'USER_ORG_MAPPING_FAILED';

export const SHOW_ADD_INSTITUTION_MANUALLY = false;

export const COURSE_SETTINGS_REQUESTED = 'COURSE_SETTINGS_REQUESTED';
export const COURSE_SETTINGS_FETCHED = 'COURSE_SETTINGS_FETCHED';
export const COURSE_SETTINGS_FAILED = 'COURSE_SETTINGS_FAILED';

export const COURSE_SETTINGS_KEYS = {
  AET_SESSION_COUNT: 'aetSessionCount',
  HAS_STUDENTS: 'hasStudents',
  LAST_NOTIFIED_PAST_DUE_DATE: 'lastNotifiedPastDueDate',
  TEMPORARY_ACCESS_EXPIRY_BANNER_DISMISSED: 'temporaryAccessExpiryBannerDismissed'
};

export const ASK_AI_PROMPT_KEY = 'ASK_AI_PROMPT';

export const OVERALL_STATUS = {
  EXCELLING: 'excelling',
  FALLING_BEHIND: 'falling_behind',
  KEEPING_UP: 'keeping_up'
};

export const FOOTER_CTA_LINKS = {
  ASK_AI: 'ask-ai',
  REVIEW_READING: 'review-reading'
};

export const COURSE_FORM_MODES = {
  CREATE: 'create',
  COPY: 'copy',
  EDIT: 'edit'
};

export const COURSE_CREATION_REQUESTED = 'COURSE_CREATION_REQUESTED';
export const COURSE_CREATION_COMPLETED = 'COURSE_CREATION_COMPLETED';
export const COURSE_CREATION_FAILED = 'COURSE_CREATION_FAILED';
export const COURSE_EDIT_REQUESTED = 'COURSE_EDIT_REQUESTED';
export const COURSE_EDIT_COMPLETED = 'COURSE_EDIT_COMPLETED';
export const COURSE_EDIT_FAILED = 'COURSE_EDIT_FAILED';

export const USER_PROFILE_ROLES = {
  INSTRUCTOR_REVEL_VALIDATED: 'instructor_revel_validated'
};

export const COURSES_SORT_BY = {
  LAST_VIEWED: 'last_viewed',
  RECENTLY_ADDED: 'recently_added',
  A_Z: 'a_z',
  Z_A: 'z_a'
};

export const COURSES_FILTER_OPTIONS = [
  { id: COURSES_SORT_BY.LAST_VIEWED, label: 'aet.instructorCourse.coursesSort.lastViewed' },
  { id: COURSES_SORT_BY.RECENTLY_ADDED, label: 'aet.instructorCourse.coursesSort.recentlyAdded' },
  { id: COURSES_SORT_BY.A_Z, label: 'aet.instructorCourse.coursesSort.aToZ' },
  { id: COURSES_SORT_BY.Z_A, label: 'aet.instructorCourse.coursesSort.zToA' }
];

export const COURSE_FORM_DEFAULT_PAYLOAD = {
  sectionStatus: 'active',
  sectionType: 'COURSE',
  courseType: 'STANDALONE',
  courseClassification: 'Standalone',
  sectionClassificationCode: 'Standalone',
  dataRetentionExcluded: false,
  enrollable: true,
  originatingFlow: 'console',
  integrationType: 'STANDARD_INTEGRATION',
  mappings: { externallyPaired: 'false' },
  productType: 'FULL',
  brand: { name: 'Pearson eText' },
  externalPairing: false,
  description: '',
  contextName: 'ConsoleIntegration',
  courseProvisionMode: 'create',
  courseProvider: 'PearsonPlus',
  courseStatus: 'active',
  isExternallyPaired: false
};

export const BOOKSHELF_DATA_REFRESHED = 'BOOKSHELF_DATA_REFRESHED';
export const BOOKSHELF_DATA_REFRESH_FAILED = 'BOOKSHELF_DATA_REFRESH_FAILED';

export const ENROLLMENT_ROUTE = '/enrollment/:copyCode';

export const GET_COURSE_REQUESTED = 'GET_COURSE_REQUESTED';
export const GET_COURSE_COMPLETED = 'GET_COURSE_COMPLETED';
export const GET_COURSE_FAILED = 'GET_COURSE_FAILED';

export const PRINT_OFFER_REQUESTED = 'PRINT_OFFER_REQUESTED';
export const PRINT_OFFER_COMPLETED = 'PRINT_OFFER_COMPLETED';
export const PRINT_OFFER_FAILED = 'PRINT_OFFER_FAILED';

export const COURSE_COPY_REQUESTED = 'COURSE_COPY_REQUESTED';
export const COURSE_COPY_FETCHED = 'COURSE_COPY_FETCHED';
export const COURSE_COPY_FAILED = 'COURSE_COPY_FAILED';
export const COURSE_COPY_BATCH_STATUS_REQUESTED = 'COURSE_COPY_BATCH_STATUS_REQUESTED';
export const COURSE_COPY_BATCH_STATUS_FETCHED = 'COURSE_COPY_BATCH_STATUS_FETCHED';
export const COURSE_COPY_BATCH_STATUS_FAILED = 'COURSE_COPY_BATCH_STATUS_FAILED';

/** Query param value for copy form when source is another instructor (GET /sections). */
export const COPY_SOURCE_EXTERNAL = 'external';

export const COURSE_USER_ROLE = {
  STUDENT: 'student',
  INSTRUCTOR: 'instructor',
  TA: 'ta'
};

export const COURSE_USER_STATUS = {
  ACTIVE: 'active',
  INACTIVE: 'inactive'
};

export const ROSTER_ROLE_OPTIONS = [
  { label: 'aet.instructorCourse.roster.role.instructor', value: COURSE_USER_ROLE.INSTRUCTOR, hidden: true },
  { label: 'aet.instructorCourse.roster.role.student', value: COURSE_USER_ROLE.STUDENT },
  { label: 'aet.instructorCourse.roster.role.ta', value: COURSE_USER_ROLE.TA }
];

export const ROSTER_STATUS_OPTIONS = [
  { label: 'aet.instructorCourse.roster.status.active', value: 'active' },
  { label: 'aet.instructorCourse.roster.status.inactive', value: 'inactive' }
];

export const COURSE_USER_GROUP_LABEL = {
  STUDENT: 'Student',
  INSTRUCTOR: 'Instructor',
  TA: 'TA'
};

export const COURSE_USER_STATUS_LABEL = {
  ACTIVE: 'active',
  INACTIVE: 'inactive'
};

export const ROSTER_FILTER_OPTIONS = [
  {
    id: 'allMembers',
    label: 'aet.instructorCourse.manageRoster.filter.allMembers',
    value: 'all'
  },
  {
    id: 'activeStudents',
    label: 'aet.instructorCourse.manageRoster.filter.activeStudents',
    value: COURSE_USER_GROUP_LABEL,
    filters: {
      status: COURSE_USER_STATUS_LABEL.ACTIVE,
      groupType: COURSE_USER_ROLE.STUDENT
    }
  },
  {
    id: 'inactiveStudents',
    label: 'aet.instructorCourse.manageRoster.filter.inactiveStudents',
    value: 'Inactive',
    filters: {
      status: COURSE_USER_STATUS_LABEL.INACTIVE,
      groupType: COURSE_USER_ROLE.STUDENT
    }
  }
];
export const UPDATE_LOCATION_REQUESTED = 'UPDATE_LOCATION_REQUESTED';
export const UPDATE_LOCATION_COMPLETED = 'UPDATE_LOCATION_COMPLETED';
export const UPDATE_LOCATION_FAILED = 'UPDATE_LOCATION_FAILED';

export const EXPORT_PROGRESS_REQUESTED = 'EXPORT_PROGRESS_REQUESTED';
export const EXPORT_PROGRESS_COMPLETED = 'EXPORT_PROGRESS_COMPLETED';
export const EXPORT_PROGRESS_FAILED = 'EXPORT_PROGRESS_FAILED';


export const COPY_CODE_TO_COURSE_REQUESTED = 'COPY_CODE_TO_COURSE_REQUESTED';
export const COPY_CODE_TO_COURSE_COMPLETED = 'COPY_CODE_TO_COURSE_COMPLETED';
export const COPY_CODE_TO_COURSE_FAILED = 'COPY_CODE_TO_COURSE_FAILED';

export const COPY_COURSE_BATCH_STATUS = {
  SUCCEEDED: 'Succeeded',
  FAILED: 'Failed',
  PARTIALLY_FAILED: 'PartiallyFailed',
  FAILED_PERMANENTLY: 'FailedPermanently',
  NOT_APPLICABLE: 'NotApplicable'
};

export const COPY_COURSE_ERROR_CODES = {
  PRODUCT_IS_NOT_COPYABLE: 179,
  NO_OFFERS_AVAILABLE: 107
};

export const PRODUCT_COPY_ERROR_CODES = [
  COPY_COURSE_ERROR_CODES.PRODUCT_IS_NOT_COPYABLE,
  COPY_COURSE_ERROR_CODES.NO_OFFERS_AVAILABLE
];

export const EXPIRED_BANNER_ID = 'expired';
export const INACTIVE_BANNER_ID = 'inactive';

export const AET_ONBOARDING_VARIANT = {
  V1: 'v1',
  V2: 'v2'
};

export const CHANNELS_ACCESS_REQUESTED = 'CHANNELS_ACCESS_REQUESTED';

/** Static Auth Home Study Prep visibility defaults (not derived from book/user context). */
export const AUTH_HOME_STUDY_PREP_DEFAULT_VISIBILITY = {
  showPPlusResourcesContainer: false,
  showStudyPrepPromoCard: false
};

export const TEMP_ACCESS_PAYMENT_METHOD = 'TEMPACCESS';

/** Manage roster eTextbook Access column display types. */
export const MANAGE_ROSTER_ACCESS_DISPLAY = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  TEMP_ACCESS: 'tempAccess',
  NOT_AVAILABLE: 'notAvailable'
};

/** Maps payment method type codes to manage roster access display types. */
export const MANAGE_ROSTER_PAYMENT_METHOD_ACCESS_MAP = {
  OLP: MANAGE_ROSTER_ACCESS_DISPLAY.ACTIVE,
  ACCESSCODE: MANAGE_ROSTER_ACCESS_DISPLAY.ACTIVE,
  TEMPACCESS: MANAGE_ROSTER_ACCESS_DISPLAY.TEMP_ACCESS,
  INSTITUTIONAL_BILLING: MANAGE_ROSTER_ACCESS_DISPLAY.ACTIVE,
  INCLUSIVE_ACCESS: MANAGE_ROSTER_ACCESS_DISPLAY.ACTIVE,
  CP_PAID: MANAGE_ROSTER_ACCESS_DISPLAY.ACTIVE,
  SEAT_LICENSE_REDEMPTION: MANAGE_ROSTER_ACCESS_DISPLAY.ACTIVE,
  DUAL_CREDIT: MANAGE_ROSTER_ACCESS_DISPLAY.ACTIVE,
  OPT_OUT: MANAGE_ROSTER_ACCESS_DISPLAY.INACTIVE,
  ADMIN_ADDED: MANAGE_ROSTER_ACCESS_DISPLAY.ACTIVE,
  CANCELED: MANAGE_ROSTER_ACCESS_DISPLAY.INACTIVE,
  DDA_OPT_OUT: MANAGE_ROSTER_ACCESS_DISPLAY.INACTIVE,
  DDA_OPT_IN: MANAGE_ROSTER_ACCESS_DISPLAY.ACTIVE,
  INACTIVE: MANAGE_ROSTER_ACCESS_DISPLAY.INACTIVE
};

export const TEMP_ACCESS_WARNING_DAYS_THRESHOLD = 10;

/** `heroView` Marquee/AWS keys for temp access banner copy. */
export const TEMP_ACCESS_BANNER_MESSAGE = {
  WARNING_BANNER: 'TEMP_ACCESS_WARNING_BANNER_MESSAGE',
  MANAGE_ROSTER_BANNER: 'TEMP_ACCESS_MANAGE_ROSTER_BANNER_MESSAGE'
};

export const INLINE_ACTION_ALERT_FEEDBACK_VARIANT = {
  WARNING: 'warning',
  ALERT: 'alert',
  INFO: 'info'
};

export const MANAGE_ROSTER_TEMP_ACCESS_CONFIG = {
  showEmailAction: true
};

export const TEMP_ACCESS_UPGRADE_HELP_URL = 'https://support.pearson.com/getsupport/s/document-item?language=in&bundleId=3pl-cg-student&topicId=Content/upgrade_temp_access.htm&_LANG=in';
